/**
 * Узбекский перевод (латиница).
 *
 * Ключ — русский текст из кода. Порядок разделов повторяет порядок экранов,
 * чтобы при добавлении строки было понятно, куда её класть.
 *
 * Терминология спецтранспорта аэропорта сверена с бланком путевого листа:
 * «путевой лист» — yo‘l varaqasi, «гаражный номер» — garaj raqami,
 * «моточас» — moto soat, «ГСМ» — YoMM (yoqilg‘i-moylash materiallari).
 */
export const uz: Record<string, string> = {
  // ─── Навигация ────────────────────────────────────────────────────────────
  Главная: 'Bosh sahifa',
  HR: 'HR',
  Сотрудники: 'Xodimlar',
  Структура: 'Tuzilma',
  Должности: 'Lavozimlar',
  Автопарк: 'Avtopark',
  Транспорт: 'Transport',
  Водители: 'Haydovchilar',
  Эксплуатация: 'Ekspluatatsiya',
  'Путевые листы': 'Yo‘l varaqalari',
  ГСМ: 'YoMM',
  Отчёты: 'Hisobotlar',
  Пользователи: 'Foydalanuvchilar',
  Справочники: 'Maʼlumotnomalar',
  Администрирование: 'Ma’muriyat',
  'Журнал действий': 'Amallar jurnali',
  'Свернуть меню': 'Menyuni yig‘ish',
  'Развернуть меню': 'Menyuni ochish',
  'Версия платформы': 'Platforma versiyasi',
  'Изменить ширину меню': 'Menyu kengligini o‘zgartirish',
  Выйти: 'Chiqish',

  // ─── Общие действия и подписи ────────────────────────────────────────────
  Сохранить: 'Saqlash',
  Отмена: 'Bekor qilish',
  Удалить: 'O‘chirish',
  Заменить: 'Almashtirish',
  'Загрузить или заменить фото': 'Suratni yuklash yoki almashtirish',
  Изменить: 'Tahrirlash',
  'Изменение путевого листа': 'Yo‘l varaqasini tahrirlash',
  'Изменения сохранены': 'O‘zgarishlar saqlandi',
  Создать: 'Yaratish',
  Добавить: 'Qo‘shish',
  Поиск: 'Qidiruv',
  Загрузка: 'Yuklanmoqda',
  'Нет данных': 'Ma’lumot yo‘q',
  Действия: 'Amallar',
  Подтвердить: 'Tasdiqlash',
  Закрыть: 'Yopish',
  Печать: 'Chop etish',
  Скачать: 'Yuklab olish',
  Обновить: 'Yangilash',
  Категория: 'Toifa',
  Статус: 'Holat',
  Состояние: 'Holati',
  Период: 'Davr',
  Дата: 'Sana',
  Примечание: 'Izoh',
  Основание: 'Asos',
  Телефон: 'Telefon',
  Адрес: 'Manzil',
  Город: 'Shahar',
  Активен: 'Faol',
  'В работе': 'Ishlamoqda',
  Отключён: 'O‘chirilgan',
  'Всего:': 'Jami:',
  'Записей:': 'Yozuvlar:',
  Модель: 'Rusumi',
  Наименование: 'Nomi',
  Код: 'Kodi',
  Тип: 'Turi',
  'Часовой пояс': 'Vaqt mintaqasi',

  // ─── Таблицы: настройка колонок ──────────────────────────────────────────
  'Вернуть исходный порядок и ширину колонок':
    'Ustunlarning dastlabki tartibi va kengligini qaytarish',

  // ─── Вход ────────────────────────────────────────────────────────────────
  'Вход в систему': 'Tizimga kirish',
  'Учёт и контроль спецтранспорта аэропортов': 'Aeroport maxsus transportini hisobga olish va nazorat qilish',
  'Электронная почта': 'Elektron pochta',
  Пароль: 'Parol',
  Войти: 'Kirish',
  'Нет доступа?': 'Kirish huquqi yo‘qmi?',
  // Платформа: организации и их офисы
  'Офис добавлен': 'Ofis qo‘shildi',
  'В организации пока нет офисов': 'Tashkilotda hali ofislar yo‘q',
  'Код офиса входит в номера документов и после создания не меняется': 'Ofis kodi hujjat raqamlariga kiradi va yaratilgandan keyin o‘zgarmaydi',
  'Новый офис': 'Yangi ofis',
  'Нажмите на строку организации, чтобы раскрыть её офисы. Офис не удаляется — он отключается: исчезает из переключателя и рабочих списков, а техника, путевые листы и история остаются, и включить его можно в любой момент.': 'Ofislarini ochish uchun tashkilot qatorini bosing. Ofis o‘chirilmaydi — u faolsizlantiriladi: almashtirgich va ishchi ro‘yxatlardan yo‘qoladi, texnika, yo‘l varaqalari va tarix saqlanib qoladi, uni istalgan vaqtda qayta yoqish mumkin.',
  // Телеметрия: карта Google
  'Карта Google недоступна — показана резервная': 'Google xaritasi mavjud emas — zaxira xarita ko‘rsatildi',
  'Карта не подключена': 'Xarita ulanmagan',
  'В сборке сайта не задан ключ карт (переменная VITE_GOOGLE_MAPS_API_KEY). Добавьте его в .env.production на сервере и пересоберите сайт — карта появится сама.': 'Sayt yig‘ilishida xarita kaliti (VITE_GOOGLE_MAPS_API_KEY) belgilanmagan. Uni serverdagi .env.production fayliga qo‘shing va saytni qayta yig‘ing — xarita o‘zi paydo bo‘ladi.',
  'Карта Google не открылась': 'Google xaritasi ochilmadi',
  // Печать путевого листа
  'Заправки по листу': 'Varaqa bo‘yicha yoqilg‘i quyishlar',
  'Расшифровка расчёта нормы': 'Me’yor hisobining tafsiloti',
  'Заключения': 'Xulosalar',
  'Подпись': 'Imzo',
  'Медработник': 'Tibbiyot xodimi',
  'Путевой лист выдан': 'Yo‘l varaqasi berildi',
  'Допущен к рейсу': 'Reysga ruxsat berildi',
  'Допущен с замечаниями': 'Izohlar bilan ruxsat berildi',
  'Выпуск разрешён': 'Chiqishga ruxsat berildi',
  'Выпуск разрешён с замечаниями': 'Izohlar bilan chiqishga ruxsat berildi',
  'Выпуск запрещён': 'Chiqish taqiqlandi',
  // Территория офиса
  'Территория офиса на карте': 'Ofis hududi xaritada',
  'Карта телеметрии не уходит дальше этого расстояния от центра': 'Telemetriya xaritasi markazdan bu masofadan uzoqqa ketmaydi',
  'Выбор на карте работает с картой Google — задайте её ключ в сборке сайта': 'Xaritada tanlash Google xaritasi bilan ishlaydi — sayt yig‘ilishida uning kalitini belgilang',
  'Указать на карте': 'Xaritada ko‘rsatish',
  'Ничего не найдено — уточните запрос или найдите место на карте': 'Hech narsa topilmadi — so‘rovni aniqlang yoki joyni xaritadan toping',
  'Поиск по адресу не включён: в Google Cloud включите Geocoding API и добавьте его в ограничения ключа. Место можно найти на карте вручную.': 'Manzil bo‘yicha qidiruv yoqilmagan: Google Cloud’da Geocoding API’ni yoqing va uni kalit cheklovlariga qo‘shing. Joyni xaritadan qo‘lda topish mumkin.',
  'Территория офиса': 'Ofis hududi',
  'Применить': 'Qo‘llash',
  'Найдите место поиском или передвиньте карту, затем щёлкните по центру территории (базы, аэропорта, склада). Радиус — насколько далеко от центра работает техника офиса.': 'Joyni qidiruv orqali toping yoki xaritani suring, so‘ng hudud markazini (baza, aeroport, ombor) bosing. Radius — ofis texnikasi markazdan qanchalik uzoqda ishlashi.',
  'Найти': 'Topish',
  'Адрес или название места, например: Самарканд, аэропорт': 'Manzil yoki joy nomi, masalan: Samarqand, aeroport',
  'Карта Google недоступна': 'Google xaritasi mavjud emas',
  'Радиус, км': 'Radius, km',
  'Центр не выбран — щёлкните по карте': 'Markaz tanlanmagan — xaritani bosing',
  'Безопасность дорог': 'Yo‘l xavfsizligi',
  'Лимит нарушений': 'Qoidabuzarliklar chegarasi',
  'За период, месяцев': 'Davr, oy',
  // Печать: выдача в обход, масштаб листа
  'Выдан без заключения по решению диспетчера': 'Dispetcher qarori bilan xulosasiz berilgan',
  'Содержимое не помещается на один лист даже в мелком масштабе — низ листа обрезан. Сократите задания или примечание.': 'Mazmun hatto kichik masshtabda ham bir varaqqa sig‘maydi — varaqning pastki qismi kesilgan. Topshiriqlar yoki izohni qisqartiring.',
  'Лист уменьшен до': 'Varaq kichraytirildi:',
  'чтобы поместиться на одну страницу — проверьте, читается ли шрифт.': 'bir sahifaga sig‘ishi uchun — matn o‘qilishini tekshiring.',
  // Справочники организации
  'Справочник организации — общий для всех её офисов, у других организаций свой. Изменять может администратор организации. Плотность нужна для перевода литров в тонны — бухгалтерия считает ГСМ в килограммах.': 'Tashkilot ma’lumotnomasi — uning barcha ofislari uchun umumiy, boshqa tashkilotlarda o‘ziniki. Faqat tashkilot administratori o‘zgartira oladi. Zichlik litrni tonnaga o‘tkazish uchun kerak — buxgalteriya YoMMni kilogrammda hisoblaydi.',
  'Справочник организации — общий для всех её офисов: так сравнивается расход одинаковой техники в разных офисах. Изменять может администратор организации. Тип счётчика определяет, по какой базе считается норма расхода.': 'Tashkilot ma’lumotnomasi — uning barcha ofislari uchun umumiy: shunday qilib turli ofislardagi bir xil texnika sarfi solishtiriladi. Faqat tashkilot administratori o‘zgartira oladi. Hisoblagich turi sarf me’yori qaysi asosda hisoblanishini belgilaydi.',
  'Организация сама заводит свои типы допусков — «Охраняемая территория», «Склад ГСМ» и т.п. Справочник общий для всех её офисов, изменять может администратор организации. Технике можно назначить требуемый тип в её карточке, сотруднику выдаётся сам допуск в карточке сотрудника.': 'Tashkilot o‘z ruxsatnoma turlarini o‘zi yaratadi — «Qo‘riqlanadigan hudud», «YoMM ombori» va h.k. Ro‘yxat uning barcha ofislari uchun umumiy, faqat tashkilot administratori o‘zgartira oladi. Texnikaga uning kartasida talab qilinadigan tur belgilanadi, xodimga ruxsatnomaning o‘zi xodim kartasida beriladi.',
  'Каталог документов личного дела — «Паспорт», «Диплом», «Виза» и т.п. — организация заводит сама; он общий для всех её офисов, изменять может администратор организации. Сами документы прикрепляются в карточке сотрудника.': 'Shaxsiy hujjatlar katalogi — «Pasport», «Diplom», «Viza» va h.k. — tashkilot tomonidan yaratiladi va uning barcha ofislari uchun umumiy; faqat tashkilot administratori o‘zgartira oladi. Hujjatlarning o‘zi xodim kartasiga biriktiriladi.',
  'Поставщики ГСМ и подрядчики по ремонту. Справочник организации — общий для всех её офисов, изменять может администратор организации.': 'YoMM yetkazib beruvchilar va ta’mirlash pudratchilari. Tashkilot ma’lumotnomasi — uning barcha ofislari uchun umumiy, faqat tashkilot administratori o‘zgartira oladi.',
  'Справочник службы безопасности дорог — общий для всех офисов организации, у других организаций свой. Изменять может администратор организации.': 'Yo‘l xavfsizligi xizmati ma’lumotnomasi — tashkilotning barcha ofislari uchun umumiy, boshqa tashkilotlarda o‘ziniki. Faqat tashkilot administratori o‘zgartira oladi.',
  'Общий справочник платформы — география страны, одна для всех организаций. Нужен для раскладки задания «Регион / Район». Изменять может только суперадминистратор.': 'Platformaning umumiy ma’lumotnomasi — mamlakat geografiyasi, barcha tashkilotlar uchun bitta. «Viloyat / Tuman» topshiriq tartibi uchun kerak. Faqat superadministrator o‘zgartira oladi.',
  'Номенклатура организации — общая для всех её офисов, остатки — свои у каждого склада. Позиции заводят администратор организации, администратор офиса, начальник автослужбы и кладовщик; изменять и отключать их может только администратор организации.': 'Tashkilot nomenklaturasi — uning barcha ofislari uchun umumiy, qoldiqlar har bir omborda o‘ziniki. Pozitsiyalarni tashkilot administratori, ofis administratori, avtoxizmat boshlig‘i va omborchi kiritadi; ularni faqat tashkilot administratori o‘zgartira yoki o‘chira oladi.',
  // Глобальные настройки
  'Глобальные настройки': 'Global sozlamalar',
  // Резервуары
  'Резервуары топливного склада активного офиса — свои у каждого офиса. Пустую ёмкость можно удалить; если в ней остаётся топливо, система попросит сначала списать остаток актом инвентаризации в разделе «Топливо».': 'Faol ofis yoqilg‘i omborining rezervuarlari — har bir ofisda o‘ziniki. Bo‘sh rezervuarni o‘chirish mumkin; agar unda yoqilg‘i qolsa, tizim avval «Yoqilg‘i» bo‘limida inventarizatsiya akti bilan qoldiqni hisobdan chiqarishni so‘raydi.',
  // Заявки на транспорт
  'Заявки на транспорт': 'Transport arizalari',
  'Заявка на транспорт': 'Transport arizasi',
  'Заявка': 'Ariza',
  'Новая': 'Yangi',
  'Выполнена': 'Bajarilgan',
  'Отменена': 'Bekor qilingan',
  'Новые': 'Yangilar',
  'Назначены': 'Tayinlanganlar',
  'Выполнены': 'Bajarilganlar',
  'Отменены': 'Bekor qilinganlar',
  'Принять заявку': 'Ariza qabul qilish',
  'Новая заявка на транспорт': 'Yangi transport arizasi',
  'Заявка принята': 'Ariza qabul qilindi',
  'Заявка сохранена': 'Ariza saqlandi',
  'Заявка назначена': 'Ariza tayinlandi',
  'Заявка отменена': 'Ariza bekor qilindi',
  'Заявка снята с путевого листа': 'Ariza yo‘l varaqasidan olib tashlandi',
  'Нет прав на просмотр заявок': 'Arizalarni ko‘rish huquqi yo‘q',
  'Номер, заказчик, маршрут': 'Raqam, buyurtmachi, yo‘nalish',
  'Заказчик': 'Buyurtmachi',
  'Маршрут': 'Yo‘nalish',
  'Нужна техника': 'Kerakli texnika',
  'пасс.': 'yo‘lovchi',
  'т': 't',
  'Назначить машину': 'Mashina tayinlash',
  'Отменить заявку': 'Arizani bekor qilish',
  'Снять заявку с путевого листа?': 'Ariza yo‘l varaqasidan olib tashlansinmi?',
  'Задание будет удалено из листа, заявка снова будет ждать машину.': 'Topshiriq varaqadan o‘chiriladi, ariza yana mashina kutadi.',
  'Снять': 'Olib tashlash',
  'Снять с путевого листа': 'Yo‘l varaqasidan olib tashlash',
  'Когда нужна машина': 'Mashina qachon kerak',
  'Укажите время подачи': 'Mashina berilish vaqtini ko‘rsating',
  'До какого времени': 'Qaysi vaqtgacha',
  'Окончание должно быть позже начала': 'Tugash vaqti boshlanishdan keyin bo‘lishi kerak',
  'Подразделение-заказчик': 'Buyurtmachi bo‘linma',
  'Не из подразделений офиса': 'Ofis bo‘linmalaridan emas',
  'Кто заказал': 'Kim buyurtma qildi',
  'Укажите заказчика': 'Buyurtmachini ko‘rsating',
  'ФИО или должность': 'F.I.Sh. yoki lavozim',
  'Телефон для связи': 'Aloqa telefoni',
  'Какая техника нужна': 'Qanday texnika kerak',
  'Любая': 'Istalgan',
  'Пассажиров': 'Yo‘lovchilar',
  'Груз, т': 'Yuk, t',
  'Цель поездки': 'Safar maqsadi',
  'Назначить заявку': 'Arizani tayinlash',
  'Назначить': 'Tayinlash',
  'В оформленный лист': 'Rasmiylashtirilgan varaqaga',
  'Новый путевой лист': 'Yangi yo‘l varaqasi',
  'На это время нет оформленных путевых листов': 'Bu vaqtga rasmiylashtirilgan yo‘l varaqalari yo‘q',
  'нужная категория': 'mos turdagi',
  'Выберите технику': 'Texnikani tanlang',
  'Выберите водителя': 'Haydovchini tanlang',
  'Период путевого листа': 'Yo‘l varaqasi davri',
  'Будет создан черновик путевого листа с заданием по этой заявке. Выдать его водителю можно в журнале путевых листов.': 'Ushbu ariza bo‘yicha topshiriqli yo‘l varaqasi qoralamasi yaratiladi. Uni haydovchiga yo‘l varaqalari jurnalida berish mumkin.',
  'По заявке': 'Ariza bo‘yicha',
  // Заявки на транспорт — меню
  'Заявки': 'Arizalar',
  // Заявки на транспорт — перепечатка
  'Лист уже выдан водителю — после назначения перепечатайте его и сообщите водителю о новом задании.': 'Varaqa haydovchiga allaqachon berilgan — tayinlagandan so‘ng uni qayta chop eting va haydovchiga yangi topshiriq haqida xabar bering.',
  'Задание будет удалено из выданного листа — перепечатайте лист и сообщите водителю.': 'Topshiriq berilgan varaqadan o‘chiriladi — varaqani qayta chop eting va haydovchiga xabar bering.',
  // Пользователи
  'скрыто': 'yashirin',
  // Экран входа
  'Платформа управления автопарком': 'Avtoparkni boshqarish platformasi',
  'Отправьте письмо на электронную почту': 'Elektron pochtaga xat yuboring',
  'Восстановление пароля FleetCore': 'FleetCore parolini tiklash',
  'Укажите в письме свою почту для входа — администратор задаст новый пароль.': 'Xatda kirish uchun pochtangizni ko‘rsating — administrator yangi parol o‘rnatadi.',
  'Введите электронную почту': 'Elektron pochtani kiriting',
  'Неверный формат электронной почты': 'Elektron pochta formati noto‘g‘ri',
  'Пароль — не короче 8 символов': 'Parol kamida 8 ta belgidan iborat bo‘lishi kerak',
  'Добро пожаловать в FleetCore!': 'FleetCore’ga xush kelibsiz!',
  'Войдите, чтобы продолжить работу': 'Ishni davom ettirish uchun tizimga kiring',
  'Сегодня': 'Bugun',
  'Вход…': 'Kirilmoqda…',
  'Обратитесь к администратору вашего офиса': 'Ofisingiz administratoriga murojaat qiling',
  'учётные записи заводятся вручную, самостоятельной регистрации в системе нет.':
    'hisob yozuvlari qo‘lda yaratiladi, tizimda mustaqil ro‘yxatdan o‘tish yo‘q.',

  // ─── Главная ─────────────────────────────────────────────────────────────
  'Единиц техники': 'Texnika birligi',
  'В строю': 'Saf holatida',
  Водителей: 'Haydovchilar soni',
  'Открытых путевых листов': 'Ochiq yo‘l varaqalari',
  'Остатки в ёмкостях': 'Sig‘imlardagi qoldiq',
  'Истекающие документы': 'Muddati tugayotgan hujjatlar',
  'Осталось дней': 'Qolgan kunlar',
  Просрочено: 'Muddati o‘tgan',

  // ─── Транспорт ───────────────────────────────────────────────────────────
  'Транспорт и спецтехника': 'Transport va maxsus texnika',
  'Поставить на учёт': 'Hisobga qo‘yish',
  'Гаражный номер, госномер, VIN': 'Garaj raqami, davlat raqami, VIN',
  Гаражный: 'Garaj raqami',
  'Гаражный номер': 'Garaj raqami',
  Госномер: 'Davlat raqami',
  'Одометр, км': 'Spidometr, km',
  Моточасы: 'Moto soat',
  'В баке, л': 'Bakda, l',
  Фото: 'Foto',
  'Показать фото': 'Fotoni ko‘rsatish',
  Загружено: 'Yuklandi',
  'Сейчас за рулём': 'Hozir boshqarmoqda',
  Свободна: 'Bo‘sh',
  'Списать технику с учёта?': 'Texnika hisobdan chiqarilsinmi?',
  'Документы за прошлые периоды сохранятся.': 'O‘tgan davr hujjatlari saqlanadi.',
  Списать: 'Hisobdan chiqarish',
  'Техника списана с учёта': 'Texnika hisobdan chiqarildi',
  'Нет прав на просмотр транспорта': 'Transportni ko‘rish huquqi yo‘q',
  'Выберите офис': 'Ofisni tanlang',
  'Дата создания': 'Yaratilgan sana',
  'Обратитесь в службу поддержки': 'Qo‘llab-quvvatlash xizmatiga murojaat qiling',
  'Топливо, техника, путевые листы и нарушения — в одной системе': 'Yoqilg‘i, texnika, yo‘l varaqalari va qoidabuzarliklar — yagona tizimda',
  'Вход в аккаунт': 'Hisobga kirish',
  'Добро пожаловать!': 'Xush kelibsiz!',
  'Введите почту и пароль': 'Pochta va parolni kiriting',
  'Забыли пароль?': 'Parolni unutdingizmi?',
  'Введите пароль': 'Parolni kiriting',
  'Пароль сбрасывает администратор вашего офиса — обратитесь к нему, и он задаст новый.': 'Parolni ofis administratori tiklaydi — unga murojaat qiling, u yangisini o‘rnatadi.',
  'Понятно': 'Tushunarli',
  'не указан': 'ko‘rsatilmagan',
  'Доступно офисов': 'Mavjud ofislar',
  'Карта Яндекса не подключена': 'Yandex xaritasi ulanmagan',
  'В сборке сайта не задан ключ Яндекс.Карт (переменная VITE_YANDEX_MAPS_API_KEY). Добавьте его в настройках сайта на Render и пересоберите сайт — карта появится сама.': 'Ushbu build’da Yandex xaritalari kaliti (VITE_YANDEX_MAPS_API_KEY) belgilanmagan. Uni Render’dagi sayt sozlamalariga qo‘shing va saytni qayta yig‘ing — xarita o‘zi paydo bo‘ladi.',
  'Широта': 'Kenglik',
  'Долгота': 'Uzunlik',
  'Центр карты телеметрии. Чтобы узнать координаты: на Яндекс.Картах щёлкните правой кнопкой по нужному месту — они появятся в подсказке.': 'Telemetriya xaritasi markazi. Koordinatalarni bilish uchun: Yandex xaritalarida kerakli joyga sichqonchaning o‘ng tugmasini bosing — ular maslahatda ko‘rinadi.',
  'Карта Яндекса недоступна — показана резервная (OpenStreetMap)': 'Yandex xaritasi mavjud emas — zaxira xarita (OpenStreetMap) ko‘rsatilmoqda',
  'Новая геозона': 'Yangi geozona',
  'Геозона сохранена': 'Geozona saqlandi',
  'Геозона создана': 'Geozona yaratildi',
  'Геозона удалена': 'Geozona o‘chirildi',
  'Состояние геозоны изменено': 'Geozona holati o‘zgartirildi',
  'Добавить зону': 'Zona qo‘shish',
  'Действует': 'Amal qiladi',
  'Удалить геозону?': 'Geozona o‘chirilsinmi?',
  'Вместе с ней удалятся и записанные въезды и выезды. Чтобы сохранить историю, лучше отключить зону.': 'U bilan birga qayd etilgan kirish va chiqishlar ham o‘chadi. Tarixni saqlash uchun zonani o‘chirib qo‘ygan yaxshi.',
  'Обведите зону на карте: минимум три точки, контур нужно замкнуть.': 'Zonani xaritada chizing: kamida uchta nuqta, kontur yopiq bo‘lishi kerak.',
  'Контур пересекает сам себя — поправьте точки.': 'Kontur o‘zini kesib o‘tmoqda — nuqtalarni to‘g‘rilang.',
  'Щёлкайте по карте, ставя углы зоны.': 'Zona burchaklarini qo‘yish uchun xaritaga bosing.',
  'Поставьте ещё точки — нужно минимум три.': 'Yana nuqtalar qo‘ying — kamida uchta kerak.',
  'Замкните контур: щёлкните по первой точке или нажмите «Замкнуть».': 'Konturni yoping: birinchi nuqtaga bosing yoki “Yopish” tugmasini bosing.',
  'Теперь щёлкните точку на границе круга — это задаст радиус.': 'Endi aylana chegarasidagi nuqtaga bosing — bu radiusni belgilaydi.',
  'Теперь щёлкните противоположный угол прямоугольника.': 'Endi to‘rtburchakning qarama-qarshi burchagiga bosing.',
  'Щёлкните центр круга.': 'Aylana markaziga bosing.',
  'Щёлкните один из углов прямоугольника.': 'To‘rtburchakning bir burchagiga bosing.',
  'Тяните точки, чтобы подвинуть. Щёлкните по линии — добавится точка. Двойной щелчок по точке удаляет её.': 'Nuqtalarni surish uchun torting. Chiziqqa bossangiz nuqta qo‘shiladi. Nuqtaga ikki marta bossangiz o‘chadi.',
  'Многоугольник': 'Ko‘pburchak',
  'Круг': 'Doira',
  'Прямоугольник': 'To‘rtburchak',
  'Замкнуть': 'Yopish',
  'Убрать последнюю точку': 'Oxirgi nuqtani olib tashlash',
  'Обвести заново': 'Qaytadan chizish',
  'Радиус, м': 'Radius, m',
  'Подложка карты не загрузилась — проверьте подключение к интернету. Зону можно обвести и без неё.': 'Xarita foni yuklanmadi — internet aloqasini tekshiring. Zonani u holda ham chizish mumkin.',
  'Площадь': 'Maydon',
  'га': 'ga',
  'м²': 'm²',
  'Например: Перрон 2': 'Masalan: Perron 2',
  'Цвет': 'Rang',
  'Цвета': 'Ranglar',
  'Ограничение скорости, км/ч': 'Tezlik cheklovi, km/soat',
  'Если техника едет быстрее внутри зоны, появится оповещение. Пусто — без ограничения.': 'Texnika zona ichida bundan tez yursa, ogohlantirish chiqadi. Bo‘sh — cheklovsiz.',
  'Оповещать о въезде': 'Kirishda ogohlantirish',
  'Оповещать о выезде': 'Chiqishda ogohlantirish',
  'Зона действует': 'Zona amal qiladi',
  'Как у организации': 'Tashkilotdagi kabi',
  'Раскладка задания': 'Topshiriq ko‘rinishi',
  'Общие для всех офисов организации. Отдельному офису можно задать свою раскладку.': 'Tashkilotning barcha ofislari uchun umumiy. Alohida ofis o‘z ko‘rinishini belgilashi mumkin.',
  'По умолчанию раскладка общая для всей организации. Свою задают только офисам, которым она нужна отдельно.': 'Odatda ko‘rinish butun tashkilot uchun umumiy. O‘zinikini faqat alohida kerak bo‘lgan ofislarga belgilang.',
  'Администратор организации': 'Tashkilot administratori',
  'Видит и ведёт все офисы выбранных организаций, но не чужие. Ниже укажите хотя бы один офис — в него человек попадает после входа.': 'Tanlangan tashkilotlarning barcha ofislarini ko‘radi va boshqaradi, boshqalarniki emas. Quyida kamida bitta ofisni ko‘rsating — kirgandan keyin shu ofisga tushadi.',
  'Не администратор организации': 'Tashkilot administratori emas',
  'Платформа': 'Platforma',
  'Организации': 'Tashkilotlar',
  'Организация': 'Tashkilot',
  'Офисов': 'Ofislar soni',
  'Суперадминистраторы': 'Superadministratorlar',
  'Нет прав на управление платформой': 'Platformani boshqarish huquqi yo‘q',
  'Создать организацию': 'Tashkilot yaratish',
  'Новая организация': 'Yangi tashkilot',
  'Организация создана': 'Tashkilot yaratildi',
  'Организация обновлена': 'Tashkilot yangilandi',
  'Состояние организации изменено': 'Tashkilot holati o‘zgartirildi',
  'Отключена': 'O‘chirilgan',
  'Отключить организацию?': 'Tashkilot o‘chirilsinmi?',
  'Включить организацию?': 'Tashkilot yoqilsinmi?',
  'Все её офисы исчезнут из переключателя, сотрудники не смогут войти. Данные сохранятся.': 'Uning barcha ofislari almashtirgichdan yo‘qoladi, xodimlar kira olmaydi. Ma’lumotlar saqlanadi.',
  'Офисы организации вернутся в переключатель.': 'Tashkilot ofislari almashtirgichga qaytadi.',
  'Организация — отдельный клиент платформы, например «Аэропорты Узбекистана» или TOSHSHAHARNUR. Данные разных организаций не смешиваются. Отключённая организация закрывает вход во все свои офисы, история при этом сохраняется.': 'Tashkilot — platformaning alohida mijozi, masalan “O‘zbekiston aeroportlari” yoki TOSHSHAHARNUR. Turli tashkilotlar ma’lumotlari aralashmaydi. O‘chirilgan tashkilot barcha ofislariga kirishni yopadi, tarix saqlanadi.',
  '2–16 заглавных латинских букв или цифр. После создания не меняется.': '2–16 ta bosh lotin harfi yoki raqam. Yaratilgandan keyin o‘zgarmaydi.',
  '2–16 заглавных латинских букв или цифр': '2–16 ta bosh lotin harfi yoki raqam',
  'Суперадминистратор платформы видит все организации и офисы, в том числе созданные позже, и может переключаться между ними. Администратор офиса работает только в рамках своего офиса. Статус выдаётся отметкой в карточке пользователя.': 'Platforma superadministratori barcha tashkilot va ofislarni, jumladan keyin yaratilganlarini ko‘radi va ular orasida almashadi. Ofis administratori faqat o‘z ofisi doirasida ishlaydi. Maqom foydalanuvchi kartochkasidagi belgi bilan beriladi.',
  'Добавить суперадминистратора': 'Superadministrator qo‘shish',
  'Суперадминистратор платформы': 'Platforma superadministratori',
  'Суперадминистратор платформы отмечается отдельно и видит все офисы всех организаций, в том числе созданные позже.': 'Platforma superadministratori alohida belgilanadi va barcha tashkilotlarning barcha ofislarini, jumladan keyin yaratilganlarini ko‘radi.',
  'Полный доступ ко всем организациям и офисам, управление организациями и офисами. Ниже укажите хотя бы один офис — в него человек попадает после входа.': 'Barcha tashkilot va ofislarga to‘liq kirish, ularni boshqarish. Quyida kamida bitta ofisni ko‘rsating — kirgandan keyin shu ofisga tushadi.',
  'Выберите организацию': 'Tashkilotni tanlang',
  'Клиент платформы, которому принадлежит офис. После создания не меняется.': 'Ofis tegishli bo‘lgan platforma mijozi. Yaratilgandan keyin o‘zgarmaydi.',
  'ни разу': 'hech qachon',
  'Укажите дату': 'Sanani kiriting',

  // ─── Водители ────────────────────────────────────────────────────────────
  'Принять водителя': 'Haydovchini qabul qilish',
  'Фамилия или табельный номер': 'Familiya yoki tabel raqami',
  Табельный: 'Tabel raqami',
  ФИО: 'F.I.O.',
  Подразделение: 'Bo‘linma',
  'Ближайший срок': 'Eng yaqin muddat',
  'нет документов': 'hujjatlar yo‘q',
  '(просрочен)': '(muddati o‘tgan)',
  Работает: 'Ishlamoqda',
  Уволен: 'Ishdan bo‘shatilgan',
  'Удалить водителя?': 'Haydovchi o‘chirilsinmi?',
  'Водитель удалён': 'Haydovchi o‘chirildi',
  'Водитель принят': 'Haydovchi qabul qilindi',
  'Карточка обновлена': 'Karta yangilandi',
  'Нет прав на просмотр водителей': 'Haydovchilarni ko‘rish huquqi yo‘q',
  'Дата приёма': 'Qabul sanasi',
  'Дата увольнения': 'Bo‘shatish sanasi',
  Должность: 'Lavozim',
  'Должность водителя': 'Haydovchi lavozimi',
  'Сейчас на технике': 'Hozir texnikada',
  'Не за рулём': 'Boshqarmayapti',
  'Должности водителей': 'Haydovchilar lavozimlari',
  'Список должностей свой у каждого подразделения: водитель легкового транспорта в службе спецтранспорта и водитель погрузчика на складе — разные записи, даже если оба «водитель».':
    'Har bir bo‘limning o‘z lavozimlar ro‘yxati bor: maxsus transport xizmatidagi yengil avtomobil haydovchisi va ombordagi pogruzchik haydovchisi — ikkalasi ham "haydovchi" bo‘lsa-da, alohida yozuvlar.',
  'Сначала выберите подразделение': 'Avval bo‘limni tanlang',
  Масштаб: 'Masshtab',
  'Перетащите фото и настройте масштаб, чтобы выбрать область для квадратного снимка':
    'Kvadrat surat uchun hududni tanlash uchun rasmni suring va masshtabni sozlang',
  Фамилия: 'Familiya',
  Имя: 'Ism',
  Отчество: 'Otasining ismi',
  'Дата рождения': 'Tug‘ilgan sana',
  'Табельный номер': 'Tabel raqami',
  'Обязательное поле': 'Majburiy maydon',
  'После заполнения водитель исчезнет из списка выдачи путевых листов':
    'To‘ldirilgandan so‘ng haydovchi yo‘l varaqasi beriladiganlar ro‘yxatidan chiqadi',
  Передать: 'O‘tkazish',
  'Приказ № ... от ...': 'Buyruq № ... sanasi ...',

  // ─── Путевые листы ───────────────────────────────────────────────────────
  'Номер листа': 'Varaqa raqami',
  Номер: 'Raqami',
  Техника: 'Texnika',
  Водитель: 'Haydovchi',
  'Только перерасход': 'Faqat ortiqcha sarf',
  'Пробег, км': 'Yurilgan masofa, km',
  'Норма, л': 'Me’yor, l',
  'Факт, л': 'Amalda, l',
  Отклонение: 'Chetlanish',
  'Нет прав на просмотр путевых листов': 'Yo‘l varaqalarini ko‘rish huquqi yo‘q',
  'Нет прав на печать путевых листов': 'Yo‘l varaqalarini chop etish huquqi yo‘q',
  'Путевой лист не найден': 'Yo‘l varaqasi topilmadi',
  'Совет: чтобы сохранить в PDF, в диалоге печати выберите «Сохранить как PDF»':
    'Maslahat: PDF sifatida saqlash uchun chop etish oynasida "PDF sifatida saqlash"ni tanlang',
  Диспетчер: 'Dispetcher',
  Сформировано: 'Shakllantirildi',

  // ─── Нарушения (служба безопасности дорог) ───────────────────────────────
  Нарушения: 'Buzilishlar',
  'Нет прав на просмотр нарушений': 'Buzilishlarni ko‘rish huquqi yo‘q',
  'Оформление нарушения': 'Buzilishni rasmiylashtirish',
  'Оформить нарушение': 'Buzilishni rasmiylashtirish',
  'Вид нарушения': 'Buzilish turi',
  'Виды нарушений': 'Buzilish turlari',
  'Сумма штрафа': 'Jarima summasi',
  Штраф: 'Jarima',
  'Штраф по умолчанию': 'Standart jarima summasi',
  Описание: 'Tavsif',
  'Фото/вложение': 'Foto/ilova',
  'Сфотографировать / выбрать файл': 'Suratga olish / faylni tanlash',
  'Нарушение оформлено': 'Buzilish rasmiylashtirildi',
  Участники: 'Ishtirokchilar',
  Нарушение: 'Buzilish',
  Доказательство: 'Dalil',
  'Сохранение…': 'Saqlanmoqda…',
  Регион: 'Viloyat',
  Район: 'Tuman',
  Районы: 'Tumanlar',
  'Регионы и районы': 'Viloyatlar va tumanlar',
  'Регион / Район (административное деление)': 'Viloyat / Tuman (ma’muriy bo‘linish)',
  'Адрес А': 'A manzil',
  'Адрес Б': 'B manzil',
  Локация: 'Joylashuv',
  'Локации заданий': 'Topshiriq joylashuvlari',
  'Поля заданий путевого листа': 'Yo‘l varaqasi topshirig‘i maydonlari',
  Раскладка: 'Ko‘rinish',
  'Рейс/Борт/Стоянка — для аэропортов; Адрес А/Б — для остальных сфер':
    'Reys/Bort/Turargoh — aeroportlar uchun; A/B manzil — boshqa sohalar uchun',
  '«Адрес А» — список локаций': '"A manzil" — joylashuvlar ro‘yxatidan tanlash',
  'Вместо свободного текста — выбор из справочника «Локации заданий»':
    'Erkin matn o‘rniga «Topshiriq joylashuvlari» ma’lumotnomasidan tanlash',
  'Нумерация документов': 'Hujjat raqamlash',
  'Префикс по каждому виду документа, например «ТТН» вместо «PL» — под собственную нумерацию организации. Пустое поле — значение платформы по умолчанию.':
    'Har bir hujjat turi uchun prefiks — tashkilotning o‘z raqamlash tartibiga moslash uchun. Bo‘sh maydon — platforma standart qiymati.',
  'Заглавные буквы, цифры, дефис, до 12 символов': 'Bosh harflar, raqamlar, defis, 12 belgigacha',
  'Приход ГСМ': 'YONM kirimi',
  'Выдача ГСМ': 'YONM chiqimi',
  'Наряд-заказ': 'Naryad-buyurtma',
  'Инвентаризационный акт': 'Inventarizatsiya dalolatnomasi',
  'Акт состояния техники': 'Texnika holati dalolatnomasi',
  'Приход ТМЦ': 'TMB kirimi',
  'Выдача ТМЦ': 'TMB chiqimi',
  'Возврат ТМЦ': 'TMB qaytarilishi',
  'Списание ТМЦ': 'TMB hisobdan chiqarilishi',
  'Перемещение ТМЦ': 'TMB ko‘chirilishi',
  'Склад №1': '1-son ombor',
  'Рейс / Борт / Стоянка (авиация)': 'Reys / Bort / Turargoh (aviatsiya)',
  'Адрес А / Адрес Б (универсальная)': 'A manzil / B manzil (universal)',
  'Новая ёмкость': 'Yangi rezervuar',
  'Изменить ёмкость': 'Rezervuarni tahrirlash',
  'Ёмкость добавлена': 'Rezervuar qo‘shildi',
  'Ёмкость изменена': 'Rezervuar o‘zgartirildi',
  'Ёмкость удалена': 'Rezervuar o‘chirildi',
  'Удалить ёмкость?': 'Rezervuar o‘chirilsinmi?',
  'Короткий код, уникальный в пределах офиса, например REZ-2':
    'Ofis doirasida noyob qisqa kod, masalan REZ-2',
  'Резервуар ДТ №2': 'DT rezervuari №2',
  'Вместимость, л': 'Sig‘imi, l',
  'Порог низкого остатка, л': 'Past qoldiq chegarasi, l',
  'Ниже этого остатка ёмкость подсвечивается как требующая внимания':
    'Bu qoldiqdan past bo‘lsa, rezervuar e’tibor talab qilinadigan sifatida belgilanadi',
  'Текущий остаток, л': 'Joriy qoldiq, l',
  'Если ёмкость уже эксплуатируется и в ней есть топливо — укажите остаток на момент постановки на учёт. По умолчанию 0.':
    'Agar rezervuar allaqachon ishlatilayotgan bo‘lsa va unda yoqilg‘i bo‘lsa — hisobga olish vaqtidagi qoldiqni kiriting. Standart qiymat — 0.',
  'Топливный склад, сектор B': 'Yoqilg‘i ombori, B sektori',
  Неактивна: 'Faol emas',
  'Выключенная ёмкость остаётся в истории, но не предлагается для новых операций':
    'O‘chirilgan rezervuar tarixda qoladi, lekin yangi amallar uchun taklif qilinmaydi',
  'Мобильный режим': 'Mobil rejim',
  'Открыть мобильный экран для оформления в поле': 'Joyida rasmiylashtirish uchun mobil ekranni ochish',
  'Оформить ещё одно': 'Yana birini rasmiylashtirish',
  'Начните вводить фамилию': 'Familiyani kiriting',
  'Гаражный номер или госномер': 'Garaj raqami yoki davlat raqami',
  'Нет доступа': 'Ruxsat yo‘q',
  'У вашей учётной записи нет прав на оформление нарушений':
    'Sizning hisobingizda buzilishlarni rasmiylashtirish huquqi yo‘q',
  'Удалить запись о нарушении?': 'Buzilish yozuvi o‘chirilsinmi?',
  Оформил: 'Rasmiylashtirdi',
  'Справочник службы безопасности дорог. Свой у каждого аэропорта: перечень нарушений и суммы штрафов по умолчанию могут отличаться.':
    'Yo‘l xavfsizligi xizmati ma’lumotnomasi. Har bir aeroportda o‘ziniki: buzilishlar ro‘yxati va standart jarima summalari farq qilishi mumkin.',

  // ─── Категории техники ───────────────────────────────────────────────────
  'Перронный автобус': 'Perron avtobusi',
  'Тягач (pushback)': 'Tortuvchi (pushback)',
  'Багажный тягач': 'Bagaj tortuvchisi',
  'Ленточный транспортёр': 'Tasmali transportyor',
  Амбулифт: 'Ambulift',
  Деайсер: 'Muzdan tozalagich',
  Топливозаправщик: 'Yoqilg‘i quyish mashinasi',
  'Источник питания (GPU)': 'Quvvat manbai (GPU)',
  'Установка воздушного запуска': 'Havo bilan ishga tushirish qurilmasi',
  'Кондиционер ВС': 'Havo kemasi konditsioneri',
  'Машина бортпитания': 'Bort taomlari mashinasi',
  Водозаправщик: 'Suv quyish mashinasi',
  Ассенизатор: 'Assenizator',
  'Контейнерный погрузчик': 'Konteyner yuklagichi',
  Снегоуборочная: 'Qor tozalagich',
  'Пожарный автомобиль': 'Yong‘in o‘chirish avtomobili',
  Легковой: 'Yengil avtomobil',
  'Служебный автобус': 'Xizmat avtobusi',
  Грузовой: 'Yuk avtomobili',
  Автопогрузчик: 'Avtoyuklagich',
  Прицеп: 'Tirkama',
  'Стационарное оборудование': 'Statsionar uskuna',
  Прочее: 'Boshqa',

  // ─── Состояние техники ───────────────────────────────────────────────────
  'На ТО': 'TXKda',
  'В ремонте': 'Ta’mirda',
  'В резерве': 'Zaxirada',
  'В передаче': 'O‘tkazilmoqda',
  Списана: 'Hisobdan chiqarilgan',

  // ─── Счётчики и владение ────────────────────────────────────────────────
  'Одометр (км)': 'Spidometr (km)',
  'Одометр и моточасы': 'Spidometr va moto soat',
  'Без счётчика': 'Hisoblagichsiz',
  Собственная: 'Xususiy',
  Лизинг: 'Lizing',
  Аренда: 'Ijara',

  // ─── Документы и допуски ────────────────────────────────────────────────
  'Свидетельство о регистрации': 'Ro‘yxatdan o‘tkazish guvohnomasi',
  Техосмотр: 'Texnik ko‘rik',
  'Пропуск на перрон': 'Perronga ruxsatnoma',
  'Свидетельство о поверке': 'Tekshiruv guvohnomasi',
  'Договор лизинга': 'Lizing shartnomasi',
  Тахограф: 'Taxograf',
  'Водительское удостоверение': 'Haydovchilik guvohnomasi',
  Медосмотр: 'Tibbiy ko‘rik',
  'Допуск: перрон': 'Ruxsat: perron',
  'Допуск: контролируемая зона': 'Ruxsat: nazorat zonasi',
  'Допуск: ВПП': 'Ruxsat: UUYo',
  'Допуск: площадь манёврирования': 'Ruxsat: manyovr maydoni',
  'Допуск: привокзальная зона': 'Ruxsat: vokzal oldi hududi',
  'Привокзальная зона': 'Vokzal oldi hududi',
  'Контролируемая зона': 'Nazorat zonasi',
  Перрон: 'Perron',
  'Площадь манёврирования': 'Manyovr maydoni',
  ВПП: 'UUYo',

  // ─── Статусы путевого листа ─────────────────────────────────────────────
  Черновик: 'Qoralama',
  Выдан: 'Berilgan',
  Сдан: 'Topshirilgan',
  Закрыт: 'Yopilgan',
  Аннулирован: 'Bekor qilingan',

  // ─── Нормы и источники топлива ──────────────────────────────────────────
  'л на 100 км': '100 km ga l',
  'л на моточас': 'moto soatga l',
  'л на операцию': 'amalga l',
  'л на т·км': 't·km ga l',
  'л на смену': 'smenaga l',
  'Из ёмкости': 'Sig‘imdan',
  'Топливная карта': 'Yoqilg‘i kartasi',
  Наличные: 'Naqd pul',
  'Сторонний поставщик': 'Tashqi yetkazib beruvchi',

  // ─── Офисы ───────────────────────────────────────────────────────────────
  'Головной офис': 'Bosh ofis',
  Аэропорт: 'Aeroport',
  Филиал: 'Filial',
  Логотип: 'Logotip',
  'Подключить аэропорт': 'Aeroportni ulash',
  'Загрузить логотип': 'Logotipni yuklash',
  'Заменить логотип': 'Logotipni almashtirish',
  'Удалить логотип?': 'Logotip o‘chirilsinmi?',
  'Логотип обновлён': 'Logotip yangilandi',
  'Логотип удалён': 'Logotip o‘chirildi',
  'Отключить офис?': 'Ofis o‘chirilsinmi?',
  'Включить офис?': 'Ofis yoqilsinmi?',
  Отключить: 'O‘chirish',
  Включить: 'Yoqish',
  'Состояние офиса изменено': 'Ofis holati o‘zgartirildi',
  'Офис обновлён': 'Ofis yangilandi',
  'Аэропорт подключён': 'Aeroport ulandi',

  // ─── Единицы, общие поля ────────────────────────────────────────────────
  км: 'km',
  мч: 'mch',
  шт: 'dona',
  'л/100 км': 'l/100 km',
  'л/мч': 'l/mch',
  Офис: 'Ofis',
  Офисы: 'Ofislar',
  'Офисы и аэропорты': 'Ofislar va aeroportlar',
  Название: 'Nomi',
  'Название (рус)': 'Nomi (rus)',
  'Название (узб)': 'Nomi (o‘zb)',
  'Название (англ)': 'Nomi (ingl)',
  Язык: 'Til',
  Русский: 'Ruscha',
  Ўзбекча: 'O‘zbekcha',
  Комментарий: 'Izoh',
  Причина: 'Sabab',
  Источник: 'Manba',
  Объект: 'Obyekt',
  'ID объекта': 'Obyekt ID',
  'IP-адрес': 'IP manzil',
  'Идентификатор запроса': 'So‘rov identifikatori',
  Поле: 'Maydon',
  Было: 'Avval',
  Стало: 'Keyin',
  Кто: 'Kim',
  'Кто/что': 'Kim/nima',
  Когда: 'Qachon',
  Куда: 'Qayerga',
  Начало: 'Boshlanishi',
  Окончание: 'Tugashi',
  Результат: 'Natija',
  Осталось: 'Qoldi',
  Удалено: 'O‘chirildi',
  Активна: 'Faol',
  Активно: 'Faol',
  Используется: 'Ishlatilmoqda',
  Назначена: 'Tayinlangan',
  Сбросить: 'Tiklash',
  Провести: 'O‘tkazish',
  'Операция выполнена': 'Amal bajarildi',
  'Запись удалена': 'Yozuv o‘chirildi',
  'Удалить запись?': 'Yozuv o‘chirilsinmi?',
  'Выгрузить в Excel': 'Excelga yuklab olish',
  'Показывать отключённые': 'O‘chirilganlarni ko‘rsatish',

  // ─── Транспорт: карточка и форма ────────────────────────────────────────
  'Общие сведения': 'Umumiy ma’lumot',
  'Категория техники': 'Texnika toifasi',
  'Модель техники': 'Texnika rusumi',
  'Модели техники': 'Texnika rusumlari',
  Категории: 'Toifalar',
  Производитель: 'Ishlab chiqaruvchi',
  Владение: 'Egalik',
  'Год выпуска': 'Ishlab chiqarilgan yil',
  Год: 'Yil',
  'Дата ввода в эксплуатацию': 'Foydalanishga topshirilgan sana',
  'Инвентарный номер': 'Inventar raqami',
  Инвентарный: 'Inventar',
  'Ёмкость бака, л': 'Bak sig‘imi, l',
  'Тип счётчика': 'Hisoblagich turi',
  Счётчик: 'Hisoblagich',
  Счётчики: 'Hisoblagichlar',
  Одометр: 'Spidometr',
  'Число мест': 'O‘rinlar soni',
  'Нужен допуск на перрон': 'Perronga ruxsat kerak',
  'Допуск на перрон': 'Perronga ruxsat',
  'Выберите категорию': 'Toifani tanlang',
  'Выберите модель': 'Rusumni tanlang',
  'Корректировка показаний': 'Ko‘rsatkichlarni to‘g‘rilash',
  'Скорректировать показания': 'Ko‘rsatkichlarni to‘g‘rilash',
  'Показания скорректированы': 'Ko‘rsatkichlar to‘g‘rilandi',
  'Замена одометра, акт № ... от ...': 'Spidometr almashtirildi, dalolatnoma № ... sanasi ...',
  'Основание обязательно — оно останется в истории':
    'Asos majburiy — u tarixda saqlanib qoladi',
  'Позже изменяется только корректировкой с указанием основания':
    'Keyinchalik faqat asos ko‘rsatilgan to‘g‘rilash orqali o‘zgaradi',
  'У тягачей основная база — моточасы, у автобусов — пробег':
    'Tortuvchilarda asosiy baza — moto soat, avtobuslarda — yurilgan masofa',
  'Определяет, по какой базе считается норма расхода':
    'Sarf me’yori qaysi baza bo‘yicha hisoblanishini belgilaydi',
  'Если включено, водителя без действующего допуска система не выпустит в смену':
    'Yoqilgan bo‘lsa, amaldagi ruxsatnomasi yo‘q haydovchi smenaga chiqarilmaydi',

  // ─── Документы техники и допуски водителя ───────────────────────────────
  Документ: 'Hujjat',
  'Тип документа': 'Hujjat turi',
  'Добавить документ': 'Hujjat qo‘shish',
  'Документ добавлен': 'Hujjat qo‘shildi',
  'Документ удалён': 'Hujjat o‘chirildi',
  'Удалить документ?': 'Hujjat o‘chirilsinmi?',
  'Документ техники': 'Texnika hujjati',
  'Дата выдачи': 'Berilgan sana',
  'Кем выдан': 'Kim tomonidan berilgan',
  'Действует с': 'Amal qiladi',
  'Действует до': 'Amal qilish muddati',
  'Сумма (для страховок)': 'Summa (sug‘urta uchun)',
  'По этой дате документ попадает в дашборд истекающих сроков':
    'Shu sana bo‘yicha hujjat muddati tugayotganlar ro‘yxatiga tushadi',
  Допуски: 'Ruxsatnomalar',
  'Допуск добавлен': 'Ruxsatnoma qo‘shildi',
  'Удалить допуск?': 'Ruxsatnoma o‘chirilsinmi?',
  Зона: 'Zona',
  Удостоверения: 'Guvohnomalar',
  'Удостоверение добавлено': 'Guvohnoma qo‘shildi',
  'Удалить удостоверение?': 'Guvohnoma o‘chirilsinmi?',
  Медосмотры: 'Tibbiy ko‘riklar',
  'Медосмотр зафиксирован': 'Tibbiy ko‘rik qayd etildi',
  'Зафиксировать осмотр': 'Ko‘rikni qayd etish',
  Врач: 'Shifokor',
  'Алкотестер, ‰': 'Alkotester, ‰',
  Давление: 'Bosim',
  Температура: 'Harorat',
  Годен: 'Yaroqli',
  'Годен с ограничениями': 'Cheklov bilan yaroqli',
  'Не годен': 'Yaroqsiz',
  'Только для периодического осмотра — предрейсовый действует одну смену':
    'Faqat davriy ko‘rik uchun — reys oldi ko‘rigi bir smena amal qiladi',
  'Для работы на перроне нужен допуск APRON или выше':
    'Perronda ishlash uchun APRON yoki undan yuqori ruxsat kerak',

  // ─── Фотографии ─────────────────────────────────────────────────────────
  Фотографии: 'Fotosuratlar',
  'Фотографий нет': 'Fotosuratlar yo‘q',
  'Загрузить фотографии': 'Fotosuratlarni yuklash',
  'Фотография удалена': 'Fotosurat o‘chirildi',
  'Удалить фотографию?': 'Fotosurat o‘chirilsinmi?',
  'Сделать главным': 'Asosiy qilish',
  'Главное фото изменено': 'Asosiy fotosurat o‘zgartirildi',

  // ─── ГСМ ────────────────────────────────────────────────────────────────
  'Горюче-смазочные материалы': 'Yoqilg‘i-moylash materiallari',
  'Движение ГСМ': 'YoMM harakati',
  Топливо: 'Yoqilg‘i',
  'Вид топлива': 'Yoqilg‘i turi',
  'Виды топлива': 'Yoqilg‘i turlari',
  'Дизельное топливо': 'Dizel yoqilg‘isi',
  Ёмкость: 'Sig‘im',
  База: 'Baza',
  'Бак, л': 'Bak, l',
  'В баке': 'Bakda',
  Приход: 'Kirim',
  'Приход, л': 'Kirim, l',
  'Сумма прихода': 'Kirim summasi',
  'Топливо оприходовано': 'Yoqilg‘i kirim qilindi',
  Выдача: 'Berish',
  Выдано: 'Berildi',
  'Выдать топливо': 'Yoqilg‘i berish',
  'Выдать водителю': 'Haydovchiga berish',
  'Топливо выдано': 'Yoqilg‘i berildi',
  'Принять от водителя': 'Haydovchidan qabul qilish',
  Инвентаризация: 'Inventarizatsiya',
  'Акт инвентаризации создан': 'Inventarizatsiya dalolatnomasi tuzildi',
  Акт: 'Dalolatnoma',
  'Дата замера': 'O‘lchov sanasi',
  'Фактический остаток, л': 'Haqiqiy qoldiq, l',
  'Замеренный остаток в баке, л': 'Bakda o‘lchangan qoldiq, l',
  'По учёту, л': 'Hisob bo‘yicha, l',
  'Разница, л': 'Farq, l',
  'Состав комиссии': 'Komissiya tarkibi',
  'Расхождение свыше 0,5 % от объёма ёмкости автоматически поднимет алерт.':
    'Sig‘im hajmining 0,5 % dan ortiq farqi avtomatik ogohlantirish beradi.',
  'Цена за литр': 'Bir litr narxi',
  Стоимость: 'Qiymati',
  Сумма: 'Summa',
  Плотность: 'Zichlik',
  'Плотность, кг/л': 'Zichlik, kg/l',
  'Плотность, кг/л при +20 °C': 'Zichlik, kg/l +20 °C da',
  Объём: 'Hajm',
  'Объём, л': 'Hajm, l',
  Накладная: 'Yuk xati',
  'Номер накладной': 'Yuk xati raqami',
  Поставщик: 'Yetkazib beruvchi',
  Контрагент: 'Kontragent',
  Контрагенты: 'Kontragentlar',
  'На начало, л': 'Boshiga, l',
  'На конец, л': 'Oxiriga, l',
  'Остаток на конец': 'Oxirgi qoldiq',
  'Топливо на начало': 'Boshlanishiga yoqilg‘i',
  'Израсходовано, л': 'Sarflandi, l',
  'Расход, л': 'Sarf, l',
  'Фактически, л': 'Amalda, l',
  Литров: 'Litr',
  'Одометр при заправке': 'Quyishdagi spidometr',
  'Моточасы при заправке': 'Quyishdagi moto soat',
  'Одометр при постановке, км': 'Qo‘yishdagi spidometr, km',
  'Моточасы при постановке': 'Qo‘yishdagi moto soat',
  'Нужен для сверки с путевым листом': 'Yo‘l varaqasi bilan solishtirish uchun kerak',
  'АО «Узбекнефтепродукт»': '«O‘zbekneftmahsulot» AJ',
  'ТТН-123456': 'YuX-123456',
  'А-101': 'A-101',

  // ─── Нормы ──────────────────────────────────────────────────────────────
  'Нормы расхода': 'Sarf me’yorlari',
  'Расчёт нормы': 'Me’yor hisobi',
  'Отклонение от нормы': 'Me’yordan chetlanish',
  Ставка: 'Stavka',
  Составляющая: 'Tarkibiy qism',
  'Надбавка, %': 'Ustama, %',
  'С месяца': 'Oydan',
  'По месяц': 'Oygacha',
  'На период': 'Davrga',
  'Применяется ко всей технике офиса в указанный период':
    'Ko‘rsatilgan davrda ofisning barcha texnikasiga qo‘llanadi',
  'Норм не задано — расход считаться не будет':
    'Me’yorlar belgilanmagan — sarf hisoblanmaydi',
  'Действующие нормы конкретной техники видны в её карточке.':
    'Aniq texnikaning amaldagi me’yorlari uning kartasida ko‘rinadi.',
  'Сохранена на момент закрытия. Изменение норм задним числом её не затронет.':
    'Yopilgan paytga saqlangan. Me’yorlarni keyinchalik o‘zgartirish unga ta’sir qilmaydi.',
  'Нормы задаются на модель техники или на конкретную единицу и версионируются периодом действия. Экран управления нормами ещё не сделан — сейчас они правятся через Swagger либо Prisma Studio.':
    'Me’yorlar texnika rusumiga yoki aniq birlikka belgilanadi va amal qilish davri bo‘yicha versiyalanadi. Me’yorlarni boshqarish ekrani hali tayyor emas — hozircha ular Swagger yoki Prisma Studio orqali tahrirlanadi.',
  'Это осознанно отложено: нормы утверждаются приказом по предприятию, и форму стоит делать после того, как согласован состав надбавок.':
    'Bu ataylab keyinga qoldirilgan: me’yorlar korxona buyrug‘i bilan tasdiqlanadi va shaklni ustamalar tarkibi kelishilgandan so‘ng qilish to‘g‘ri bo‘ladi.',

  // ─── Путевой лист ───────────────────────────────────────────────────────
  'Путевой лист': 'Yo‘l varaqasi',
  'Создание путевого листа': 'Yo‘l varaqasini yaratish',
  'Путевой лист создан': 'Yo‘l varaqasi yaratildi',
  Задания: 'Topshiriqlar',
  'Добавить задание': 'Topshiriq qo‘shish',
  Рейс: 'Reys',
  Борт: 'Bort',
  Стоянка: 'To‘xtash joyi',
  'Одометр на выезд': 'Chiqishdagi spidometr',
  'Одометр на возврат, км': 'Qaytishdagi spidometr, km',
  'Моточасы на выезд': 'Chiqishdagi moto soat',
  'Моточасы на возврат': 'Qaytishdagi moto soat',
  'Пробег за смену': 'Smena davomidagi masofa',
  Наработка: 'Ishlab berish',
  'Наработка водителей': 'Haydovchilar ishlab berishi',
  'Закрыть с расчётом': 'Hisob bilan yopish',
  'Пересчитать по введённым заданиям': 'Kiritilgan topshiriqlar bo‘yicha qayta hisoblash',
  Аннулировать: 'Bekor qilish',
  'Старший смены': 'Smena boshlig‘i',
  'На смену': 'Smenaga',
  Смен: 'Smenalar',
  Листов: 'Varaqalar',
  'Закрытых листов': 'Yopilgan varaqalar',
  'Если не указать, фактический расход будет принят равным нормативному — и перерасход не проявится':
    'Ko‘rsatilmasa, amaldagi sarf me’yoriy sarfga teng deb olinadi va ortiqcha sarf ko‘rinmaydi',
  'Система проверит права, допуск на перрон и медосмотр водителя. При замечаниях выдача будет заблокирована.':
    'Tizim haydovchining huquqlari, perronga ruxsati va tibbiy ko‘rigini tekshiradi. Kamchilik bo‘lsa, berish to‘xtatiladi.',
  'Выдать вопреки замечаниям (действие попадёт в журнал аудита)':
    'Kamchiliklarga qaramay berish (amal audit jurnaliga tushadi)',

  // ─── Отчёты ─────────────────────────────────────────────────────────────
  'Расход по технике': 'Texnika bo‘yicha sarf',
  'Текущий месяц': 'Joriy oy',
  'Прошлый месяц': 'O‘tgan oy',
  Квартал: 'Chorak',
  'В парке': 'Parkda',

  // ─── Пользователи и роли ────────────────────────────────────────────────
  'Управление пользователями': 'Foydalanuvchilarni boshqarish',
  'Создать пользователя': 'Foydalanuvchi yaratish',
  Пользователь: 'Foydalanuvchi',
  'ФИО или почта': 'F.I.O. yoki pochta',
  Почта: 'Pochta',
  'Новый пароль': 'Yangi parol',
  'Сбросить пароль': 'Parolni tiklash',
  'Пароль сброшен, все сессии пользователя завершены':
    'Parol tiklandi, foydalanuvchining barcha seanslari tugatildi',
  'Не короче 8 символов': '8 belgidan kam bo‘lmasin',
  'Некорректный адрес': 'Manzil noto‘g‘ri',
  Заблокирован: 'Bloklangan',
  Заблокировать: 'Bloklash',
  'Заблокировать учётную запись?': 'Hisob yozuvi bloklansinmi?',
  'Учётная запись заблокирована': 'Hisob yozuvi bloklandi',
  Приглашён: 'Taklif qilingan',
  Принят: 'Qabul qilingan',
  'Последний вход': 'Oxirgi kirish',
  'Офис по умолчанию': 'Odatiy ofis',
  'Все доступные офисы': 'Barcha mavjud ofislar',
  'Первый из назначенных': 'Tayinlanganlarning birinchisi',
  'Доступ к офисам и роли': 'Ofislarga kirish va rollar',
  'Роли в этом офисе': 'Ushbu ofisdagi rollar',
  'Выберите роли': 'Rollarni tanlang',
  Роль: 'Rol',
  Роли: 'Rollar',
  'Роли и права': 'Rollar va huquqlar',
  'Создать роль': 'Rol yaratish',
  'Роль удалена': 'Rol o‘chirildi',
  'Удалить роль?': 'Rol o‘chirilsinmi?',
  Права: 'Huquqlar',
  Прав: 'Huquq',
  'Изменить права': 'Huquqlarni o‘zgartirish',
  'Выберите хотя бы одно право': 'Kamida bitta huquqni tanlang',
  'Видит данные всех аэропортов': 'Barcha aeroportlar ma’lumotini ko‘radi',
  'В него пользователь попадает сразу после входа':
    'Foydalanuvchi kirgach shu yerga tushadi',
  'Все сессии пользователя будут завершены.':
    'Foydalanuvchining barcha seanslari tugatiladi.',
  'Все активные сессии пользователя будут завершены — он войдёт заново с новым паролем.':
    'Foydalanuvchining barcha faol seanslari tugatiladi — u yangi parol bilan qayta kiradi.',
  'Изменение набора прав действует на всех, кому роль назначена.':
    'Huquqlar to‘plamining o‘zgarishi rol tayinlangan barchaga ta’sir qiladi.',
  'Роль действует в конкретном офисе. Один человек может быть диспетчером в Ташкенте и наблюдателем в Самарканде — это две отдельные строки.':
    'Rol aniq ofisda amal qiladi. Bir kishi Toshkentda dispetcher va Samarqandda kuzatuvchi bo‘lishi mumkin — bu ikki alohida yozuv.',
  'У этого пользователя включён обход изоляции офисов. Он видит данные всех аэропортов. Признак не редактируется через интерфейс.':
    'Bu foydalanuvchida ofislar izolyatsiyasini chetlab o‘tish yoqilgan. U barcha aeroportlar ma’lumotini ko‘radi. Bu belgi interfeys orqali tahrirlanmaydi.',
  'Иванов Иван Иванович': 'Aliyev Alisher Alisherovich',

  // ─── Администрирование и справочники ────────────────────────────────────
  'Добавить офис': 'Ofis qo‘shish',
  Подразделения: 'Bo‘linmalar',
  'Служба спецтранспорта': 'Maxsus transport xizmati',
  Запчасти: 'Ehtiyot qismlar',
  Запчасть: 'Ehtiyot qism',
  'Каталожный номер': 'Katalog raqami',
  'Каталожный №': 'Katalog №',
  'Фильтр масляный': 'Moy filtri',
  'Единица измерения': 'O‘lchov birligi',
  'Ед. изм.': 'O‘lch. bir.',
  Вид: 'Turi',
  ИНН: 'STIR',
  'ОС-12345': 'AV-12345',
  Закреплено: 'Biriktirilgan',
  'Изменённые поля': 'O‘zgargan maydonlar',
  'Изменённых полей не зафиксировано': 'O‘zgargan maydonlar qayd etilmagan',
  'Дата и время': 'Sana va vaqt',
  Действие: 'Amal',
  'Дата приёмки': 'Qabul sanasi',
  'Заглавные латинские буквы, цифры и дефис': 'Bosh lotin harflari, raqamlar va defis',
  'Заглавные латинские буквы, цифры и подчёркивание':
    'Bosh lotin harflari, raqamlar va pastki chiziq',
  '2–8 заглавных латинских букв': '2–8 ta bosh lotin harfi',
  '2–8 заглавных латинских букв. После создания не меняется.':
    '2–8 ta bosh lotin harfi. Yaratilgandan keyin o‘zgarmaydi.',
  'После создания не меняется: на него ссылаются выгрузки':
    'Yaratilgandan keyin o‘zgarmaydi: unga yuklamalar murojaat qiladi',
  'Машинный идентификатор, менять после создания нельзя':
    'Mashina identifikatori, yaratilgandan keyin o‘zgartirib bo‘lmaydi',
  'Если на неё есть ссылки, запись будет отключена, а не удалена.':
    'Unga havolalar bo‘lsa, yozuv o‘chirilmaydi, balki faolsizlantiriladi.',
  'Подразделения принадлежат активному офису и не видны другим аэропортам.':
    'Bo‘linmalar faol ofisga tegishli va boshqa aeroportlarga ko‘rinmaydi.',
  'Поставщики ГСМ и подрядчики по ремонту. Свои у каждого аэропорта.':
    'YoMM yetkazib beruvchilar va ta’mir pudratchilari. Har bir aeroportda o‘ziniki.',
  'Номенклатура общая для всех аэропортов, остатки — свои у каждого склада.':
    'Nomenklatura barcha aeroportlar uchun umumiy, qoldiqlar — har bir omborda o‘ziniki.',
  'Справочник общий для всех аэропортов. Плотность нужна для перевода литров в тонны — бухгалтерия считает ГСМ в килограммах.':
    'Ma’lumotnoma barcha aeroportlar uchun umumiy. Zichlik litrni tonnaga o‘tkazish uchun kerak — buxgalteriya YoMMni kilogrammda hisoblaydi.',
  'Справочник общий для всех аэропортов намеренно: только так можно сравнить расход одинаковых тягачей в Ташкенте и Бухаре. Тип счётчика определяет, по какой базе считается норма расхода.':
    'Ma’lumotnoma ataylab barcha aeroportlar uchun umumiy: faqat shunda Toshkent va Buxorodagi bir xil tortuvchilar sarfini solishtirish mumkin. Hisoblagich turi sarf me’yori qaysi baza bo‘yicha hisoblanishini belgilaydi.',
  'Офис не удаляется — он отключается. Отключённый исчезает из переключателя и из рабочих списков, но техника, путевые листы и вся история остаются на месте, и включить его обратно можно в любой момент. Здесь, в администрировании, отключённые офисы видны всегда — иначе вернуть их было бы нечем.':
    'Ofis o‘chirilmaydi — u faolsizlantiriladi. Faolsizlantirilgani almashtirgichdan va ish ro‘yxatlaridan yo‘qoladi, lekin texnika, yo‘l varaqalari va butun tarix joyida qoladi, uni istalgan paytda qayta yoqish mumkin. Bu yerda, ma’muriyatda, faolsizlantirilgan ofislar doim ko‘rinadi — aks holda ularni qaytarish imkoni bo‘lmasdi.',
  'Журнал только для чтения — записи нельзя изменить или удалить ни через интерфейс, ни через API. Для изменений сохраняются лишь те поля, которые действительно поменялись.':
    'Jurnal faqat o‘qish uchun — yozuvlarni na interfeys, na API orqali o‘zgartirib yoki o‘chirib bo‘lmaydi. O‘zgarishlar uchun faqat haqiqatan o‘zgargan maydonlar saqlanadi.',

  // ─── Разделы, добавленные позже навигации ────────────────────────────────
  Здравпункт: 'Tibbiy punkt',
  Техконтроль: 'Texnik nazorat',
  'Склад ТМЦ': 'TMB ombori',
  Телеметрия: 'Telemetriya',
  'Роль не назначена': 'Rol biriktirilmagan',

  // ─── Журнал действий в карточке ──────────────────────────────────────────
  'Нет прав на просмотр журнала действий': 'Amallar jurnalini ko‘rish huquqi yo‘q',
  'Показаны последние изменения этой записи и связанных с ней объектов. Полный журнал с фильтрами — в разделе «Журнал действий».':
    'Ushbu yozuv va u bilan bog‘liq obyektlardagi so‘nggi o‘zgarishlar ko‘rsatilgan. Filtrlar bilan to‘liq jurnal — «Amallar jurnali» bo‘limida.',
  'Изменений не зафиксировано': 'O‘zgarishlar qayd etilmagan',
  система: 'tizim',
  'Идентификатор записи в базе данных': 'Yozuvning ma’lumotlar bazasidagi identifikatori',
  'Подключение аэропорта': 'Aeroportni ulash',
  'Файл больше 10 МБ': 'Fayl 10 MB dan katta',
  'Зимняя надбавка к норме расхода': 'Sarf me’yoriga qishki ustama',
  'Офис исчезнет из переключателя и списков. Данные и история сохранятся, включить можно в любой момент. Сотрудники этого офиса войти не смогут.':
    'Ofis almashtirgichdan va ro‘yxatlardan yo‘qoladi. Ma’lumotlar va tarix saqlanadi, istalgan paytda qayta yoqish mumkin. Bu ofis xodimlari tizimga kira olmaydi.',
  'Офис вернётся в переключатель и станет доступен сотрудникам.':
    'Ofis almashtirgichga qaytadi va xodimlar uchun ochiladi.',
  'Номер можно изменить: путевые листы связаны с водителем по карточке, а не по номеру, поэтому история не потеряется':
    'Raqamni o‘zgartirish mumkin: yo‘l varaqalari haydovchi bilan kartochka orqali bog‘langan, raqam orqali emas, shuning uchun tarix yo‘qolmaydi',

  // ─── Здравпункт ──────────────────────────────────────────────────────────
  'Заключение записано': 'Xulosa yozildi',
  'Нет прав на просмотр здравпункта': 'Tibbiy punktni ko‘rish huquqi yo‘q',
  'Здравпункт — предрейсовый осмотр': 'Tibbiy punkt — reysoldi ko‘rik',
  допущено: 'ruxsat berilgan',
  'не допущено': 'ruxsat berilmagan',
  всего: 'jami',
  'Табельный номер или фамилия': 'Tabel raqami yoki familiya',
  Все: 'Barchasi',
  'Ждут осмотра': 'Ko‘rikni kutmoqda',
  Допущены: 'Ruxsat berilgan',
  'Водителей не найдено': 'Haydovchilar topilmadi',
  Допуск: 'Ruxsat',
  Осмотрел: 'Ko‘rikdan o‘tkazdi',
  'запись с бумаги': 'qog‘ozdan kiritilgan',
  'не осматривался': 'ko‘rikdan o‘tmagan',
  Осмотреть: 'Ko‘rikdan o‘tkazish',
  Осмотр: 'Ko‘rik',
  'Записать заключение': 'Xulosani yozish',
  Заключение: 'Xulosa',
  Допущен: 'Ruxsat berildi',
  'С ограничениями': 'Cheklovlar bilan',
  'Не допущен': 'Ruxsat berilmadi',
  'Температура, °C': 'Harorat, °C',
  'При допуске с ограничениями диспетчер увидит этот текст перед выдачей путевого листа':
    'Cheklovlar bilan ruxsat berilganda dispetcher yo‘l varaqasini berishdan oldin shu matnni ko‘radi',
  'Если не указать — двенадцать часов от момента осмотра, длина смены с запасом':
    'Ko‘rsatilmasa — ko‘rik paytidan o‘n ikki soat, ya’ni smena uzunligi zaxirasi bilan',
  'Заключение подписывается вашей учётной записью и попадает в журнал действий. Изменить его нельзя — при ошибке проведите осмотр повторно.':
    'Xulosa sizning hisobingiz bilan imzolanadi va amallar jurnaliga tushadi. Uni o‘zgartirib bo‘lmaydi — xatolik bo‘lsa, ko‘rikni qaytadan o‘tkazing.',
  'Просмотр без права проводить осмотр': 'Ko‘rik o‘tkazish huquqisiz ko‘rish',

  // ─── Техконтроль механика ────────────────────────────────────────────────
  'Нет прав на просмотр техконтроля': 'Texnik nazoratni ko‘rish huquqi yo‘q',
  'Техконтроль — предрейсовый осмотр техники': 'Texnik nazorat — texnikaning reysoldi ko‘rigi',
  выпущено: 'chiqarilgan',
  'не выпущено': 'chiqarilmagan',
  'Гаражный или госномер': 'Garaj yoki davlat raqami',
  Вся: 'Barchasi',
  Выпущены: 'Chiqarilgan',
  'Техники не найдено': 'Texnika topilmadi',
  'не осматривалась': 'ko‘rikdan o‘tmagan',
  Выпустить: 'Chiqarish',
  'Не выпускать': 'Chiqarmaslik',
  'Проверенные узлы': 'Tekshirilgan uzellar',
  'Одометр на момент осмотра, км': 'Ko‘rik paytidagi odometr, km',
  'Сверяется с показанием на выезд — расхождение видно сразу':
    'Chiqishdagi ko‘rsatkich bilan solishtiriladi — tafovut darhol ko‘rinadi',
  Замечания: 'E’tirozlar',
  'При выпуске с ограничениями диспетчер увидит этот текст перед выдачей листа':
    'Cheklovlar bilan chiqarilganda dispetcher varaqani berishdan oldin shu matnni ko‘radi',
  Механик: 'Mexanik',
  'Одометр при осмотре': 'Ko‘rikdagi odometr',
  'Замечания по узлам': 'Uzellar bo‘yicha e’tirozlar',

  // ─── Склад ТМЦ: документы ────────────────────────────────────────────────
  'Документ проведён': 'Hujjat o‘tkazildi',
  'Склад-отправитель': 'Jo‘natuvchi ombor',
  Склад: 'Ombor',
  ТМЦ: 'TMB',
  'Склад-получатель': 'Qabul qiluvchi ombor',
  'Склады совпадают': 'Omborlar bir xil',
  'Накладная поставщика': 'Yetkazib beruvchi yuk xati',
  'ТТН-000123': 'YUX-000123',
  'На какую машину идут ценности. Без этого поля не собрать стоимость её содержания.':
    'Boyliklar qaysi mashinaga ketmoqda. Bu maydonsiz uni saqlash xarajatini hisoblab bo‘lmaydi.',
  'Кому выдаём': 'Kimga beramiz',
  'Кто возвращает': 'Kim qaytarmoqda',
  Сотрудник: 'Xodim',
  Получатель: 'Qabul qiluvchi',
  'таб.': 'tab.',
  'Строки документа': 'Hujjat satrlari',
  Позиция: 'Pozitsiya',
  'Выберите позицию': 'Pozitsiyani tanlang',
  'Наименование или код': 'Nomi yoki kodi',
  остаток: 'qoldiq',
  'Кол-во': 'Miqdori',
  'Укажите количество': 'Miqdorni ko‘rsating',
  'На складе': 'Omborda',
  Цена: 'Narxi',
  сум: 'so‘m',
  Обмен: 'Almashuv',
  'старое сдано': 'eskisi topshirildi',
  'Добавить строку': 'Satr qo‘shish',
  'Выдача без обмена': 'Almashuvsiz berish',
  'Эти позиции выдаются в обмен на сданное отработанное. Отметьте «старое сдано» либо укажите причину — она останется в документе.':
    'Bu pozitsiyalar topshirilgan ishlatilgan buyum evaziga beriladi. «Eskisi topshirildi» belgisini qo‘ying yoki sababni ko‘rsating — u hujjatda qoladi.',
  'Основание списания': 'Hisobdan chiqarish asosi',
  'Опишите основание': 'Asosni yozing',
  'Акт комиссии №… , порча при хранении, истёк срок годности':
    'Komissiya dalolatnomasi №… , saqlashda buzilgan, yaroqlilik muddati tugagan',
  'Причина выдачи без обмена': 'Almashuvsiz berish sababi',
  'Позиция выдаётся в обмен — укажите причину':
    'Pozitsiya almashuv evaziga beriladi — sababni ko‘rsating',
  'Первая установка на новую технику, утрата по акту':
    'Yangi texnikaga birinchi o‘rnatish, dalolatnoma bo‘yicha yo‘qotilgan',
  'Документ проводится целиком: либо все строки, либо ни одной. Номер присваивается при проведении и не меняется.':
    'Hujjat butunlay o‘tkaziladi: yo barcha satrlar, yo hech biri. Raqam o‘tkazishda beriladi va o‘zgarmaydi.',

  // ─── Склад ТМЦ: номенклатура ─────────────────────────────────────────────
  'Позиция изменена': 'Pozitsiya o‘zgartirildi',
  'Позиция заведена': 'Pozitsiya kiritildi',
  'Новая позиция номенклатуры': 'Yangi nomenklatura pozitsiyasi',
  'Уникален в пределах организации: по нему сводится расход по всем её офисам': 'Tashkilot doirasida yagona: uning barcha ofislari bo‘yicha sarf shu kod bo‘yicha jamlanadi',
  'Масло моторное 15W-40': 'Motor moyi 15W-40',
  Единица: 'O‘lchov birligi',
  необязательно: 'majburiy emas',
  'Способ учёта': 'Hisob usuli',
  'Поштучный учёт с серийным номером вводится следующим этапом; разметка нужна уже сейчас':
    'Seriya raqami bo‘yicha donalab hisob keyingi bosqichda joriy etiladi; belgilash hozirdan kerak',
  'Выдаётся в обмен на сданное отработанное':
    'Topshirilgan ishlatilgan buyum evaziga beriladi',
  'Признак для аккумуляторов и шин. При выдаче такой позиции форма предложит принять старое на склад отработанных, а без этого потребует записать причину.':
    'Akkumulyator va shinalar uchun belgi. Bunday pozitsiyani berishda shakl eskisini ishlatilgan materiallar omboriga qabul qilishni taklif etadi, aks holda sababni yozishni talab qiladi.',

  // ─── Склад ТМЦ: экран ────────────────────────────────────────────────────
  'Нет прав на просмотр склада': 'Omborni ko‘rish huquqi yo‘q',
  'Позиций в наличии': 'Mavjud pozitsiyalar',
  'Стоимость запасов': 'Zaxiralar qiymati',
  'Ниже минимума': 'Minimumdan past',
  'Старые аккумуляторы и шины, принятые при обмене и ожидающие сдачи':
    'Almashuvda qabul qilingan va topshirishni kutayotgan eski akkumulyator va shinalar',
  'К утилизации': 'Utilizatsiyaga',
  'ед.': 'dona',
  позиций: 'pozitsiya',
  'на сумму': 'summasi',
  ответственный: 'mas’ul',
  'движений сегодня': 'bugungi harakatlar',
  Возврат: 'Qaytarish',
  Перемещение: 'Ko‘chirish',
  Списание: 'Hisobdan chiqarish',
  'Выдать ТМЦ': 'TMB berish',
  Остатки: 'Qoldiqlar',
  'В наличии': 'Mavjud',
  'Остатков не найдено': 'Qoldiqlar topilmadi',
  Остаток: 'Qoldiq',
  'Неснижаемый запас': 'Kamaytirilmas zaxira',
  'Средняя цена': 'O‘rtacha narx',
  Учёт: 'Hisob',
  обмен: 'almashuv',
  Движения: 'Harakatlar',
  Всего: 'Jami',
  Операция: 'Amaliyot',
  'Остаток после': 'Keyingi qoldiq',
  'Куда / кому': 'Qayerga / kimga',
  Документы: 'Hujjatlar',
  'Основание выдачи': 'Berish asosi',
  Строк: 'Satrlar',
  'Кому / от кого': 'Kimga / kimdan',
  Номенклатура: 'Nomenklatura',
  'Новая позиция': 'Yangi pozitsiya',
  'Ед.': 'Birlik',
  'В офисе': 'Ofisda',
  Признаки: 'Belgilar',
  поштучно: 'donalab',
  снята: 'hisobdan olingan',

  // ─── Единицы измерения номенклатуры ──────────────────────────────────────
  // «шт» уже переведено выше, среди единиц измерения техники.
  л: 'l',
  кг: 'kg',
  м: 'm',
  компл: 'komplekt',
  упак: 'quti',
  пара: 'juft',

  // ─── Телеметрия: карта ───────────────────────────────────────────────────
  'Карта Яндекса недоступна — показана резервная':
    'Yandex xaritasi mavjud emas — zaxira xarita ko‘rsatildi',
  'Показана схема без картографической подложки': 'Xarita asosisiz sxema ko‘rsatildi',
  'Файл карты не найден. Соберите его командой npm run map:tiles — она вырезает район аэропорта из открытых данных OpenStreetMap в один файл рядом с приложением.':
    'Xarita fayli topilmadi. Uni npm run map:tiles buyrug‘i bilan yig‘ing — u OpenStreetMap ochiq ma’lumotlaridan aeroport hududini kesib, dastur yoniga bitta faylga joylaydi.',
  'У этого офиса нет своей территории': 'Bu ofisning o‘z hududi yo‘q',
  'Карта аэродрома доступна в офисе аэропорта. Переключите офис в шапке.':
    'Aerodrom xaritasi aeroport ofisida mavjud. Yuqoridan ofisni almashtiring.',
  'Карта не открылась': 'Xarita ochilmadi',
  'Нет данных для отображения: не заданы геозоны и нет точек':
    'Ko‘rsatish uchun ma’lumot yo‘q: geozonalar belgilanmagan va nuqtalar yo‘q',
  'Схема территории без картографической подложки: относительное положение техники, геозоны и курс движения.':
    'Xarita asosisiz hudud sxemasi: texnikaning nisbiy joylashuvi, geozonalar va harakat yo‘nalishi.',
  схема: 'sxema',
  Трек: 'Trek',
  'Пробег по треку': 'Trek bo‘yicha yurish',
  'Максимальная скорость': 'Maksimal tezlik',
  Точек: 'Nuqtalar',
  'Показана только часть трека': 'Trekning faqat bir qismi ko‘rsatilgan',
  'За период накопилось больше точек, чем отдаётся за один запрос. Пробег посчитан по показанной части — выберите более узкий интервал.':
    'Davr ichida bitta so‘rovda beriladiganidan ko‘ra ko‘proq nuqta to‘plangan. Yurish ko‘rsatilgan qism bo‘yicha hisoblangan — torroq oraliqni tanlang.',
  'За выбранные сутки трека нет': 'Tanlangan kun uchun trek yo‘q',
  'Карта Яндекса не открылась': 'Yandex xaritasi ochilmadi',
  'Нет прав на просмотр телеметрии': 'Telemetriyani ko‘rish huquqi yo‘q',
  'Живая карта': 'Jonli xarita',
  'Положение техники': 'Texnikaning joylashuvi',
  'С трекером': 'Trekerli',
  'Вся техника': 'Barcha texnika',
  'Обновляется автоматически каждые 15 секунд':
    'Har 15 soniyada avtomatik yangilanadi',
  'В этом офисе нет техники с трекерами': 'Bu ofisda trekerli texnika yo‘q',
  'Телеметрия ведётся по аэропортам — выберите офис аэропорта в шапке.':
    'Telemetriya aeroportlar bo‘yicha yuritiladi — yuqoridan aeroport ofisini tanlang.',
  'Техники с данными нет': 'Ma’lumotli texnika yo‘q',
  Скорость: 'Tezlik',
  'Последняя точка': 'So‘nggi nuqta',
  'трекер молчит': 'treker jim',
  'трекера нет': 'treker yo‘q',
  Трекеры: 'Trekerlar',
  'Трекеры не зарегистрированы': 'Trekerlar ro‘yxatdan o‘tkazilmagan',
  // Международные сокращения: пишутся одинаково на всех трёх языках,
  // но нужны в словаре — иначе проверка покрытия считает их пропуском.
  IMEI: 'IMEI',
  SIM: 'SIM',
  'Последний сеанс': 'So‘nggi seans',
  'не выходил на связь': 'aloqaga chiqmagan',
  снят: 'olib qo‘yilgan',
  работает: 'ishlamoqda',
  отключён: 'o‘chirilgan',
  Геозоны: 'Geozonalar',
  'Геозоны не заданы': 'Geozonalar belgilanmagan',
  Ограничение: 'Cheklov',
  Оповещения: 'Ogohlantirishlar',
  'на въезд': 'kirishda',
  'на выезд': 'chiqishda',
  'не настроены': 'sozlanmagan',
  Событий: 'Hodisalar',
  Полигон: 'Poligon',
  точек: 'nuqta',
  'не обведён': 'chizilmagan',
  События: 'Hodisalar',
  'Пересечений границ не зафиксировано': 'Chegara kesib o‘tilishi qayd etilmagan',
  Время: 'Vaqt',
  Событие: 'Hodisa',
  въезд: 'kirish',
  выезд: 'chiqish',
  Геозона: 'Geozona',

  // ─── Пользователи ────────────────────────────────────────────────────────
  'Фотография загружена': 'Surat yuklandi',
  'Заменить фото': 'Suratni almashtirish',
  'Загрузить фото': 'Surat yuklash',
  'Снимок обрезается по центру в квадрат. JPEG, PNG или WebP.':
    'Surat markazidan kvadrat shaklida kesiladi. JPEG, PNG yoki WebP.',
  Основной: 'Asosiy',
  'Служебный внутренний номер телефона — четыре цифры. По нему сотрудника набирают внутри предприятия, поэтому он идёт раньше личного. Один номер может быть закреплён за несколькими сотрудниками.':
    'Xizmat ichki telefon raqami — to‘rt raqam. Korxona ichida xodimga shu raqam orqali qo‘ng‘iroq qilinadi, shuning uchun u shaxsiy raqamdan oldin turadi. Bitta raqam bir necha xodimga biriktirilishi mumkin.',
  'Ровно четыре цифры': 'Aniq to‘rtta raqam',
  'Личный номер сотрудника': 'Xodimning shaxsiy raqami',
  'Исключение — суперадминистратор: при выборе этой роли все доступные офисы подставляются сразу.':
    'Istisno — superadministrator: bu rol tanlanganda barcha mavjud ofislar darhol qo‘yiladi.',
  'Служебный номер, ФИО или почта': 'Xizmat raqami, F.I.Sh. yoki pochta',
  'Внутренний номер не задан': 'Ichki raqam belgilanmagan',
  'действует до': 'amal qiladi',
  Показатели: 'Ko‘rsatkichlar',

  // ─── Путевой лист: допуски и состояние техники ───────────────────────────
  'Водитель не проходил предрейсовый осмотр в здравпункте.':
    'Haydovchi tibbiy punktda reysoldi ko‘rikdan o‘tmagan.',
  'Техника не проходила предрейсовый контроль технического состояния.':
    'Texnika reysoldi texnik holat nazoratidan o‘tmagan.',
  'Система проверит удостоверение, допуск на перрон, медицинское заключение и заключение механика.':
    'Tizim guvohnoma, perronga ruxsat, tibbiy xulosa va mexanik xulosasini tekshiradi.',
  'Причина выпуска без заключения механика': 'Mexanik xulosasisiz chiqarish sababi',
  'Доступно только с правом waybill.override_technical. Причина сохраняется в путевом листе и в журнале действий.':
    'Faqat waybill.override_technical huquqi bilan mumkin. Sabab yo‘l varaqasida va amallar jurnalida saqlanadi.',
  'Укажите причину': 'Sababni ko‘rsating',
  'Например: механик на выезде, осмотр внесён с бумаги':
    'Masalan: mexanik chiqishda, ko‘rik qog‘ozdan kiritilgan',
  'Выпуск невозможен': 'Chiqarish mumkin emas',
  'Механик не выпустил технику на линию. Это решение не обходится никакими правами — нужна замена машины.':
    'Mexanik texnikani liniyaga chiqarmadi. Bu qarorni hech qanday huquq bilan chetlab o‘tib bo‘lmaydi — mashinani almashtirish kerak.',
  'Состояние техники при выдаче': 'Berishda texnikaning holati',
  'Замечания при выдаче': 'Berishdagi e’tirozlar',
  'Причина выдачи без медосмотра': 'Tibbiy ko‘riksiz berish sababi',
  'Доступно только с правом waybill.override_medical. Причина сохраняется в путевом листе и в журнале действий.':
    'Faqat waybill.override_medical huquqi bilan mumkin. Sabab yo‘l varaqasida va amallar jurnalida saqlanadi.',
  'Например: здравпункт закрыт, осмотр внесён с бумаги':
    'Masalan: tibbiy punkt yopiq, ko‘rik qog‘ozdan kiritilgan',
  'Выдача невозможна': 'Berish mumkin emas',
  'Врач не допустил водителя к работе. Это решение не обходится никакими правами — нужна замена водителя.':
    'Shifokor haydovchini ishga qo‘ymadi. Bu qarorni hech qanday huquq bilan chetlab o‘tib bo‘lmaydi — haydovchini almashtirish kerak.',
  'Выдать вопреки замечаниям по документам (действие попадёт в журнал аудита)':
    'Hujjatlardagi e’tirozlarga qaramay berish (amal audit jurnaliga tushadi)',
  'Состояние техники при возврате': 'Qaytarishda texnikaning holati',
  'При выдаче было': 'Berishda edi',
  'Описание повреждений': 'Shikastlanishlar tavsifi',
  'Текст попадёт в акт — пишите так, как объясните это через месяц':
    'Matn dalolatnomaga tushadi — bir oydan keyin tushuntira oladigan qilib yozing',
  'Будет составлен акт о состоянии техники':
    'Texnikaning holati to‘g‘risida dalolatnoma tuziladi',
  'В акте будет указан водитель, принявший технику':
    'Dalolatnomada texnikani qabul qilgan haydovchi ko‘rsatiladi',
  'Путевой лист на этого водителя не создаётся. Требуется замена.':
    'Bu haydovchiga yo‘l varaqasi yaratilmaydi. Almashtirish talab etiladi.',
  'Сначала осмотр в здравпункте, затем оформление путевого листа.':
    'Avval tibbiy punktda ko‘rik, keyin yo‘l varaqasini rasmiylashtirish.',

  // ─── Подписи справочников: документы и журнал ────────────────────────────
  ОСАГО: 'MMSS (OSAGO)',
  КАСКО: 'KASKO',
  Создание: 'Yaratish',
  Изменение: 'O‘zgartirish',
  Удаление: 'O‘chirish',
  Восстановление: 'Tiklash',
  Вход: 'Kirish',
  'Неудачный вход': 'Muvaffaqiyatsiz kirish',
  Выход: 'Chiqish',
  Выгрузка: 'Yuklab olish',
  Утверждение: 'Tasdiqlash',
  Отчёт: 'Hisobot',
  'Номенклатура ТМЦ': 'TMB nomenklaturasi',
  'Фото техники': 'Texnika surati',
  'Показания счётчика': 'Hisoblagich ko‘rsatkichi',
  Удостоверение: 'Guvohnoma',
  'Допуск водителя': 'Haydovchi ruxsati',
  'Пароль пользователя': 'Foydalanuvchi paroli',
  'Фото сотрудника': 'Xodim surati',

  // ─── Подписи справочников: состояние техники ─────────────────────────────
  Исправна: 'Soz',
  'Мелкие замечания': 'Kichik e’tirozlar',
  Неисправна: 'Nosoz',
  Повреждена: 'Shikastlangan',
  ДТП: 'YTH',

  // ─── Подписи справочников: допуск врача и механика ───────────────────────
  'Предрейсовый медосмотр не пройден': 'Reysoldi tibbiy ko‘rik o‘tilmagan',
  'Врач не допустил к работе': 'Shifokor ishga qo‘ymadi',
  'Срок предрейсового допуска истёк': 'Reysoldi ruxsat muddati tugagan',
  'Допущен врачом': 'Shifokor ruxsat berdi',
  'Допущен с ограничениями': 'Cheklovlar bilan ruxsat berildi',
  'Предрейсовый техосмотр не пройден': 'Reysoldi texnik ko‘rik o‘tilmagan',
  'Механик не выпустил технику на линию': 'Mexanik texnikani liniyaga chiqarmadi',
  'Срок заключения механика истёк': 'Mexanik xulosasining muddati tugagan',
  'Техника исправна, выпуск разрешён': 'Texnika soz, chiqishga ruxsat berilgan',
  'Выпуск разрешён с ограничениями': 'Chiqishga cheklovlar bilan ruxsat berilgan',

  // ─── Подписи справочников: склад ─────────────────────────────────────────
  'Масла и смазки': 'Moylar va moylash materiallari',
  Фильтры: 'Filtrlar',
  Шины: 'Shinalar',
  Аккумуляторы: 'Akkumulyatorlar',
  'Тормозная система': 'Tormoz tizimi',
  Электрооборудование: 'Elektr uskunalari',
  'Технические жидкости': 'Texnik suyuqliklar',
  'Запасные части': 'Ehtiyot qismlar',
  'Крепёж и расходники': 'Mahkamlagichlar va sarf materiallari',
  'Инструмент и инвентарь': 'Asbob va inventar',
  'Спецодежда и СИЗ': 'Maxsus kiyim va HVV',
  'По количеству': 'Miqdor bo‘yicha',
  'Поштучно, с номером': 'Donalab, raqami bilan',
  'По партиям': 'Partiyalar bo‘yicha',
  'Основной склад': 'Asosiy ombor',
  Кладовая: 'Omborxona',
  'Отработанные материалы': 'Ishlatilgan materiallar',
  'Плановая замена': 'Rejali almashtirish',
  'Замена по износу': 'Eskirish bo‘yicha almashtirish',
  'Ремонт по наряд-заказу': 'Naryad-buyurtma bo‘yicha ta’mirlash',
  'Аварийная выдача': 'Favqulodda berish',
  'Обеспечение работника': 'Xodimni ta’minlash',
  'Возврат на склад': 'Omborga qaytarish',
  'Приём отработанного': 'Ishlatilganini qabul qilish',
  'Перемещение со склада': 'Ombordan ko‘chirish',
  'Перемещение на склад': 'Omborga ko‘chirish',
  'Корректировка по инвентаризации': 'Inventarizatsiya bo‘yicha tuzatish',

  /*
   * ─── Сообщения об ошибках сервера ──────────────────────────────────────
   *
   * Ключ — машинный код из ответа API (см. errorMessage в api/client.ts).
   * Перевода нет — показывается русский текст сервера, поэтому список
   * можно пополнять постепенно.
   *
   * Намеренно НЕ переведены коды, чьё сообщение несёт данные: остаток,
   * объём, занятый номер, дату. Сервер подстановок отдельным полем пока
   * не передаёт, и перевод по коду потерял бы цифру, ради которой
   * сообщение и читают. Их черёд — когда в ApiErrorResponse появятся
   * параметры.
   */
  'Неизвестная ошибка': 'Noma’lum xatolik',
  'error.auth.invalid_credentials': 'Pochta yoki parol noto‘g‘ri',
  'error.auth.account_locked':
    'Hisob vaqtincha bloklangan: parol bir necha marta noto‘g‘ri kiritilgan',
  'error.auth.account_inactive': 'Hisob faol emas — administratorga murojaat qiling',
  'error.auth.no_office': 'Hisobga birorta ham ofis biriktirilmagan',
  'error.auth.office_not_allowed': 'Bu ofisga kirish huquqi yo‘q',
  'error.auth.invalid_refresh_token': 'Sessiya muddati tugagan — qaytadan kiring',
  'error.auth.wrong_current_password': 'Joriy parol noto‘g‘ri',
  'error.auth.permission_denied': 'Bu amal uchun huquq yo‘q',
  'error.validation.failed': 'Shakl to‘ldirishda xatolik — maydonlarni tekshiring',
  'error.internal.error': 'Ichki xatolik. Qayta urinib ko‘ring yoki administratorga murojaat qiling.',
  'error.db.foreign_key_violation':
    'Yozuvni o‘chirib bo‘lmaydi: unga boshqa hujjatlar bog‘langan',
  'error.db.not_found': 'Yozuv topilmadi',
  'error.db.row_level_security': 'Bu ofisning ma’lumotlariga kirish huquqi yo‘q',
  'error.stock.recipient_required':
    'Qabul qiluvchini ko‘rsating: haydovchi yoki xodim',
  'error.stock.transfer_same_warehouse':
    'Jo‘natuvchi va qabul qiluvchi ombor bir xil',
  'error.stock.no_utilization_warehouse':
    'Ofisda ishlatilgan materiallar ombori yo‘q. Almashuvda eski akkumulyator va shinalarni qabul qilish uchun uni yarating.',
  'error.stock.warehouse_not_found': 'Ombor topilmadi yoki yopilgan',
  'error.stock.item_not_found': 'Nomenklatura pozitsiyasi topilmadi yoki hisobdan olingan',
  'error.stock.document_not_found': 'Hujjat topilmadi',
  'error.stock.vehicle_not_found': 'Texnika bu ofisda topilmadi',
  'error.stock.recipient_not_found': 'Qabul qiluvchi bu ofisda topilmadi',
  'error.stock.exchange_required':
    'Pozitsiya ishlatilgan buyum evaziga beriladi. Eskisini topshirilganini belgilang yoki almashuvsiz berish sababini ko‘rsating.',
  'error.waybill.not_found': 'Yo‘l varaqasi topilmadi',
  'error.waybill.invalid_period': 'Yo‘l varaqasining muddati noto‘g‘ri',
  'error.waybill.medical_clearance_required':
    'Haydovchining amaldagi reysoldi tibbiy ruxsati yo‘q',
  'error.waybill.technical_clearance_required':
    'Texnikaning amaldagi mexanik xulosasi yo‘q',
  'error.waybill.driver_not_eligible': 'Haydovchi ishga qo‘yilmagan',
  'error.waybill.invalid_transition': 'Yo‘l varaqasining joriy holatida bu amal mumkin emas',
  'error.waybill.negative_consumption': 'Sarf manfiy chiqdi — ko‘rsatkichlarni tekshiring',
  'error.driver.not_found': 'Haydovchi topilmadi',
  'error.driver.inactive': 'Haydovchi faol emas',
  'error.vehicle.not_found': 'Texnika topilmadi',
  'error.office.not_found': 'Ofis topilmadi',
  'error.user.not_found': 'Foydalanuvchi topilmadi',
  'error.user.cannot_delete_self': 'O‘z hisobingizni o‘chira olmaysiz',
  'error.role.not_found': 'Rol topilmadi',
  'error.role.system_role': 'Tizim rolini o‘chirib bo‘lmaydi',
  'error.role.in_use': 'Rol foydalanuvchilarga biriktirilgan — avval uni yechib oling',
  'error.storage.file_required': 'Fayl tanlanmagan',

  // ─── Выбор строк и выгрузка ──────────────────────────────────────────────
  Выбрано: 'Tanlandi',
  из: '/',
  'Снять выбор': 'Tanlovni bekor qilish',
  'Сводная таблица': 'Jamlanma jadval',
  'Отметьте строки галочками': 'Avval qatorlarni belgilang',
  выбранные: 'tanlanganlar',
  'весь список': 'to‘liq ro‘yxat',
  'Код обращения': 'Murojaat kodi',
  'Сбросить колонки': 'Ustunlarni tiklash',
  'Нет строк для отчёта': 'Hisobot uchun qatorlar yo‘q',
  Итого: 'Jami',
  'Загрузка строк': 'Qatorlar yuklanmoqda',
  'Формируется отчёт': 'Hisobot shakllantirilmoqda',
  Таблица: 'Jadval',
  'Печатные формы': 'Chop etish shakllari',
  Документов: 'Hujjatlar',
  'Не выбрано ни одного документа': 'Birorta hujjat tanlanmagan',
  'За один раз печатается не больше документов:': 'Bir martada chop etiladigan hujjatlar soni ko‘pi bilan:',
  'Выгрузка таблицы': 'Jadvalni yuklab olish',
  'Заправка': 'Yoqilg‘i quyish',
  'Добавить заправку': 'Yoqilg‘i quyishni qo‘shish',
  'Заправок не было': 'Yoqilg‘i quyilmagan',
  'Заправка за смену': 'Smena davomida yoqilg‘i quyish',
  'Марка': 'Marka',
  'Марка топлива': 'Yoqilg‘i markasi',
  'Литры': 'Litr',
  'Укажите объём': 'Hajmni kiriting',
  'Выберите марку': 'Markani tanlang',
  'Второй водитель': 'Ikkinchi haydovchi',
  'Наработка за смену': 'Smenadagi ish soati',
  'Одометр на возврат': 'Qaytishdagi odometr',
  'Показанием одометра': 'Odometr ko‘rsatkichi bilan',
  'Показанием моточасов': 'Motosoat ko‘rsatkichi bilan',
  'Пробегом за смену': 'Smenadagi yurish bilan',
  'Наработкой за смену': 'Smenadagi ish soati bilan',
  'Пробег вводится': 'Yurish kiritiladi',
  'Наработка вводится': 'Ish soati kiritiladi',
  'Меньше показания на выезд': 'Chiqishdagi ko‘rsatkichdan kam',
  'На выезд': 'Chiqishda',
  'Показание на возврат будет': 'Qaytishdagi ko‘rsatkich',
  'За смену': 'Smenada',
  'Пульс, уд/мин': 'Puls, zarba/daq',
  'Допуск выдаётся': 'Ruxsat beriladi',
  'Действует по (включительно)': 'Amal qiladi (shu kun ham)',
  'Укажите дату окончания': 'Tugash sanasini kiriting',
  'Фото пользователя': 'Foydalanuvchi surati',
  'После выбора файла можно выбрать область и масштаб. JPEG, PNG или WebP.': 'Fayl tanlangandan so‘ng hudud va masshtabni tanlash mumkin. JPEG, PNG yoki WebP.',
  'Адрес проживания': 'Yashash manzili',
  'Все дни периода будут отмечены в табеле этим статусом.': 'Davrning barcha kunlari tabelda shu holat bilan belgilanadi.',
  'Действ.': 'Amalda',
  'Для увольнения достаточно указать дату увольнения в «Основном».': 'Ishdan bo‘shatish uchun «Asosiy» bo‘limida bo‘shatish sanasini kiritish kifoya.',
  'Дней': 'Kun',
  'Дни этого периода будут сняты из табеля.': 'Ushbu davr kunlari tabeldan olib tashlanadi.',
  'Добавить допуск': 'Ruxsatnoma qo‘shish',
  'Добавить период': 'Davr qo‘shish',
  'Документы и допуски': 'Hujjatlar va ruxsatnomalar',
  'Документы личного дела': 'Shaxsiy ish hujjatlari',
  'Должности и переводы': 'Lavozimlar va o‘tkazishlar',
  'Допуск удалён': 'Ruxsatnoma o‘chirildi',
  'Допущен к работе': 'Ishga ruxsat berilgan',
  'Если должность предполагает управление транспортом, сотрудник появится в «Водителях»': 'Agar lavozim transport boshqarishni nazarda tutsa, xodim «Haydovchilar» ro‘yxatida paydo bo‘ladi',
  'Загрузить': 'Yuklash',
  'Изменение здесь — перевод с сегодняшнего дня. Перевод другой датой — в разделе «Должности».': 'Bu yerdagi o‘zgarish — bugundan boshlab o‘tkazish. Boshqa sana bilan o‘tkazish — «Lavozimlar» bo‘limida.',
  'История пока пуста': 'Tarix hozircha bo‘sh',
  'Итого за месяц': 'Oy bo‘yicha jami',
  'Кому звонить (ФИО, кем приходится)': 'Kimga qo‘ng‘iroq qilish (F.I.Sh., qarindoshligi)',
  'Контакты': 'Kontaktlar',
  'Контакты сохранены': 'Kontaktlar saqlandi',
  'На случай чрезвычайной ситуации': 'Favqulodda vaziyat uchun',
  'Например: Иванова Мария, жена': 'Masalan: Ivanova Mariya, rafiqasi',
  'Нарушения за период': 'Davr ichidagi qoidabuzarliklar',
  'Не допущен к работе': 'Ishga ruxsat berilmagan',
  'Неверный адрес': 'Noto‘g‘ri manzil',
  'Нет документов': 'Hujjatlar yo‘q',
  'Нет допусков': 'Ruxsatnomalar yo‘q',
  'Новый документ': 'Yangi hujjat',
  'Новый допуск': 'Yangi ruxsatnoma',
  'Новый перевод': 'Yangi o‘tkazish',
  'Новый период': 'Yangi davr',
  'Номер документа': 'Hujjat raqami',
  'Номер приказа': 'Buyruq raqami',
  'Номер приказа / больничного листа': 'Buyruq / kasallik varaqasi raqami',
  'Номер приказа о приёме': 'Ishga qabul buyrug‘i raqami',
  'Номер приказа об увольнении': 'Ishdan bo‘shatish buyrug‘i raqami',
  'Основное': 'Asosiy',
  'Основные данные': 'Asosiy ma’lumotlar',
  'Осталось, дн.': 'Qoldi, kun',
  'Остальные разделы карточки станут доступны после сохранения.': 'Kartochkaning boshqa bo‘limlari saqlangandan so‘ng ochiladi.',
  'Открыть карточку водителя': 'Haydovchi kartochkasini ochish',
  'Открыть общий табель': 'Umumiy tabelni ochish',
  'Отпуска': 'Ta’tillar',
  'Отпуска и отсутствия': 'Ta’tillar va yo‘qliklar',
  'Перевод': 'O‘tkazish',
  'Перевод внесён': 'O‘tkazish kiritildi',
  'Перевод вносится по факту — дата не позже сегодняшней': 'O‘tkazish amalda kiritiladi — sana bugundan kech bo‘lmasligi kerak',
  'Период внесён и отмечен в табеле': 'Davr kiritildi va tabelda belgilandi',
  'Период удалён, дни сняты из табеля': 'Davr o‘chirildi, kunlar tabeldan olib tashlandi',
  'Периодов нет': 'Davrlar yo‘q',
  'По': 'Gacha',
  'После заполнения сотрудник исчезнет из списков выдачи путевых листов и допусков': 'To‘ldirilgandan so‘ng xodim yo‘l varaqalari va ruxsatnomalar ro‘yxatidan chiqadi',
  'Предрейсовый медосмотр': 'Reys oldi tibbiy ko‘rik',
  'Приказ': 'Buyruq',
  'Принять сотрудника': 'Xodimni qabul qilish',
  'Приём сотрудника': 'Xodimni qabul qilish',
  'Просрочен': 'Muddati o‘tgan',
  'Пусто — документ бессрочный': 'Bo‘sh — hujjat muddatsiz',
  'Режим работы': 'Ish tartibi',
  'С': 'Dan',
  'С даты': 'Sanadan',
  'Скрыть': 'Yashirish',
  'Создан / изменён': 'Yaratilgan / o‘zgartirilgan',
  'Сотрудник принят': 'Xodim qabul qilindi',
  'Сотрудник удалён': 'Xodim o‘chirildi',
  'Сохранено': 'Saqlandi',
  'Страна выдачи': 'Berilgan mamlakat',
  'Табель': 'Tabel',
  'Текущий путевой лист': 'Joriy yo‘l varaqasi',
  'Тип допуска': 'Ruxsatnoma turi',
  'Удалить запись истории?': 'Tarix yozuvini o‘chirasizmi?',
  'Удалить карточку сотрудника?': 'Xodim kartochkasini o‘chirasizmi?',
  'Удалить период?': 'Davrni o‘chirasizmi?',
  'Укажите период': 'Davrni ko‘rsating',
  'Фото загружено': 'Surat yuklandi',
  'Фото удалено': 'Surat o‘chirildi',
  'Это текущая должность — карточка вернётся к предыдущей записи.': 'Bu joriy lavozim — kartochka oldingi yozuvga qaytadi.',
  'бессрочно': 'muddatsiz',
  'до': 'gacha',
  'за': 'uchun',
  'завершён': 'tugagan',
  'запланирован': 'rejalashtirilgan',
  'мес.': 'oy',
  'не внесено': 'kiritilmagan',
  'нет': 'yo‘q',
  'отметок нет': 'belgilar yo‘q',
  'просрочено': 'muddati o‘tgan',
  'путевые листы не выдаются': 'yo‘l varaqalari berilmaydi',
  'сейчас': 'hozir',
  'текущая': 'joriy',
  'Категории прав': 'Guvohnoma toifalari',
  'Удостоверение просрочено': 'Guvohnoma muddati o‘tgan',
  '(просрочено)': '(muddati o‘tgan)',
  'Поиск...': 'Qidiruv...',
  'Ничего не найдено': 'Hech narsa topilmadi',
  'Ничего не выбрано': 'Hech narsa tanlanmagan',
  'Выехал': 'Chiqib ketdi',
  'Выезд отмечен': 'Chiqish belgilandi',
};
